// to build run "npm run rollup:build"
import * as THREE from 'three';
window._dev = false
window._fullscreen3d = false
if(document.getElementById('_dev') != null){
    window._dev = document.getElementById('_dev').value === 'true'

}
if(typeof window.loading_steps !== "number") window.loading_steps = 0;
function log(){
    if(window._dev){
        console.log.apply(undefined, arguments)
    }
}
function error(){// you can get call stack in console
    if(window._dev){
        console.error.apply(undefined, arguments)
    }
}
function time(fun, label){// you can get complete time in console
    if(window._dev){
        console.time(label)
    }
    fun()
    if(window._dev){
        console.timeEnd(label)
    }
}
const default_objectPosition = new THREE.Vector3(0, 0, 0);
const center_of_5436 = new THREE.Vector3(0, 1, 0);

// models and scene settings for each model
let default_cameraPosX = 2;
let default_cameraPosY = 2;
let default_cameraPosZ = 2;
// let default_cameraPosX = -1;
// let default_cameraPosY = 0;
// let default_cameraPosZ = 3.5;
//
// if(PRODUCT_ID == '776'){
//     default_cameraPosX = 0;
//     default_cameraPosY = 1.8;
//     default_cameraPosZ = 3.2;
// }

let terrain = undefined;
//let onloadLength;

const width = 512;
const height = 512;
let helper;
let helper2;
let rectLight
let rectLight2
let model_settings = []
let load_spherical = new THREE.Spherical();
let changesCallBacks = {};
let changesCallBacksForColor = {};
let onloadCallBacks = {};
let onloadCallBacksForColor = {};

//let onloadLength = Object.entries(onloadCallBacks).length;
let textures = []
function imageToUint8Array(image) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    canvas.width = image.width;
    canvas.height = image.height;


    context.drawImage(image, 0, 0);
    let imageData = context.getImageData(0, 0, image.width, image.height);
    let $return = new Uint8Array(imageData.data.length);
    // // //log($return,imageData.data);
    for (let i = 0; i < imageData.data.length; i++) {
        // let gray = (imageData[nPixel] + imageData[nPixel + 1] + imageData[nPixel + 2]) / 3;

        $return[i] = imageData.data[i];
        // // //log($return[i]);

    }
    return $return;

}
function createCanvas2dContext(width = 100, height = 100){
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    canvas.width = width;
    canvas.height = height;
    return {
        canvas,
        context,
    };
}
function colorizeImage(image, color = '#808080', url) {
    let combine_color = new THREE.Color( color)
    let {context, canvas} = createCanvas2dContext(image.width, image.height)
    context.drawImage(image, 0, 0);
    let imageData = context.getImageData(0, 0, image.width, image.height);

    let pixelsOut = context.createImageData(imageData)

    let pixel_color = new THREE.Color()
    let {h, s, l} = combine_color.getHSL({})
    for (let i = 0; i < imageData.data.length / 4; i++) {

        let i4 = i * 4;
        // getting pixels
        pixel_color.r = imageData.data[i4] / 255
        pixel_color.g = imageData.data[i4 + 1] / 255
        pixel_color.b = imageData.data[i4 + 2] / 255

        // geting pixel lightnes
        let max = Math.max(pixel_color.r, pixel_color.g, pixel_color.b);
        let min = Math.min(pixel_color.r, pixel_color.g, pixel_color.b);
        let lightsMultiplier = (min + max)

        // geting pixel color
        pixel_color.setHSL(h, s, l * lightsMultiplier)

        // coloring pixels
        pixelsOut.data[i4] = pixel_color.r * 255;
        pixelsOut.data[i4 + 1] = pixel_color.g * 255;
        pixelsOut.data[i4 + 2] = pixel_color.b * 255;
        pixelsOut.data[i4 + 3] = imageData.data[i4 + 3];

    }

    // converting to obj url
    context.putImageData(pixelsOut, 0, 0)

    return new Promise(function (resolve, reject) {

        canvas.toBlob(function (blob) {
            resolve(URL.createObjectURL(blob))


        }, 'image/png')
    })
        .catch(function (e){
            console.error(e)
        })


}
function createImageElement(src = '/a.png'){
    return new Promise(function (resolve, reject){
        let img = new Image(100, 200);
        img.src = src;
        img.onload = function(){resolve(img)};
        img.onerror = reject;
    })

}

function createData(type, mimetype, canvas) {

    let value = canvas.toDataURL(mimetype);
    if (value.indexOf(mimetype) > 0) { // we check if the format is supported
        return {
            type: type,
            value: value
        }
    } else {
        return false;
    }
}

// // //log('%c#c7c7c9 %c'+new THREE.Color( 0xcFF0000 ).offsetHSL(0.75,0,0).getStyle (), 'background: #FFF; color: #c7c7c9', 'background: #FFF; color: '+new THREE.Color( 0xcFF0000 ).offsetHSL(0.75,0,-0).getStyle ());


const hdr_settings = {
    addToScene: true,
    //  url: '/images/abandoned_workshop_1k.hdr',
    //url: '/images/venice_sunset_1k.hdr',
   // url: '/models/hdr/venice_sunset_05k.hdr',
    //  url: '/models/hdr/venice_sunset_05k-2.hdr',
     // url: '/models/hdr/decor_shasdasfasfop_1k-10.hdr',
    url: '/models/hdr/StudioWhiteSoftv4.hdr',
   //   url: '/models/hdr/studio_small_05_4k.hdr',
    addAsEnvironment: true,
    addAsBackground: false,

};
const default_color_changer_meshes = {
    'side_a': {
        'index': 0,
        'remove_map': true,
    },
    'side_b': {
        'index': 1,
        'remove_map': true,
    },
    'side_c': {
        'index': 2,
        'remove_map': false,
    },
};
const control_settings = [
    {
        minDistance: 1.3,
        maxDistance: 330,
        minPolarAngle: 0,
        maxPolarAngle: Math.PI / 2,
    },
    {// show only front side
        minDistance: 1.3,
        maxDistance: 20,
        minPolarAngle: 0,
        maxPolarAngle: Math.PI / 2,
        minAzimuthAngle: -Math.PI / 2,
        maxAzimuthAngle: Math.PI / 2,

    },
    {
        minDistance: 0,
        maxDistance: Infinity,
    },
    {
        minDistance: 2.0,
        maxDistance: 20,
        minPolarAngle: 0,
        maxPolarAngle: Math.PI,
    },
];


let modelScale = 0.01;
let model_scale = document.getElementById("model_scale").getAttribute("data-val");

if (model_scale != '' && model_scale != 0) {
    modelScale = model_scale;
}
// //log(parseFloat(modelScale));
let default_objectScaleX = parseFloat(modelScale);
let default_objectScaleY = parseFloat(modelScale);
let default_objectScaleZ = parseFloat(modelScale);


let sceneInfo =
    [
        {
            name: {
                model: 'SMG1-5436',
                size: '1024',
                url_to_texture: '/models/743/SMG1-5436_gltf/1024/lambert4SG_baseColor.jpg'

            },
            url: '/models/743/SMG1-5436_gltf/1024/out.glb',
            //  url: '/models/743/SMG1-5436_gltf/1024/out-processed.glb',
            cameraPos: new THREE.Vector3(default_cameraPosX, default_cameraPosY, default_cameraPosZ),
            objectScale: new THREE.Vector3(default_objectScaleX, default_objectScaleY, default_objectScaleZ),
            // objectScale: new THREE.Vector3( 1, 1, 1 ), // Model 2
            objectPosition: default_objectPosition,
            center: center_of_5436, //recomend x, y, z  where y > 0
            shadows: true,
            color_changer_meshes: default_color_changer_meshes,
            control_settings: control_settings[0],
            hdr_settings: hdr_settings
        }
    ];
// models and scene settings for each model END

// start index
export let startModelIndex = 0;
// start index END

// settings for preview
export let state = {
    playAnimation: true
};
export const get_size_of_3d_preview = function (fullscreen = false) {
    let image_layers = document.getElementById('image_layers');
    // console.log({
    //     'width': image_layers.offsetWidth,
    //     'height': image_layers.offsetHeight,
    // })

    return {
        'width': image_layers.offsetWidth,
        'height': image_layers.offsetHeight,
    }
};
// settings for preview END

// settings for shadows
export const PLANE_WIDTH = 7;
export const PLANE_HEIGHT = 7;
export const CAMERA_HEIGHT = 3;

export const shadowState = {
    shadow: {
        blur: 3.5,
        darkness: 1,
        opacity: 1,
    },
    plane: {
        color: '#ffffff',
        opacity: 0,//turned off
    },
    // showWireframe: false,
};
// settings for shadows END

//https://github.com/mrdoob/three.js/blob/master/examples/webgl_loader_gltf_letiants.html
//https://threejs.org/examples/#webgl_loader_gltf_letiants

//nice shadow + changes to material
//https://github.com/mrdoob/three.js/blob/master/examples/webgl_materials_car.html


import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import { RectAreaLightUniformsLib } from 'three/examples/jsm/lights/RectAreaLightUniformsLib.js';
//import { RectAreaLightHelper } from 'three/examples/jsm/helpers/RectAreaLightHelper.js';
import { ProgressiveLightMap } from 'three/examples/jsm/misc/ProgressiveLightMap.js';


//import Stats from 'three/examples/jsm/libs/stats.module.js';
//const stats = new Stats();
//document.getElementById('image_layers').appendChild( stats.dom );
// code for using part of screen


let progressiveSurfacemap;
const dirLights = [], lightmapObjects = [];
const params = {
    'Light Radius': 0,
    'Blend Window': 3,
}

const shadowMapRes = 512, lightMapRes = 1024, lightCount = 8;
let size_of_3d_preview = get_size_of_3d_preview();

let orbitControls;
let camera, renderer, hemiLight, spotLight;

let object = new THREE.Mesh()
let scene = new THREE.Scene();
let lightOrigin = new THREE.Group();
lightOrigin.position.set( 0, 0.75, 1 );
lightOrigin.position.multiplyScalar( 10 );
scene.add( lightOrigin );

let lightProbe;
let directionalLight;

let pmremGenerator;
let gltf, background, envMap, mixer;
let currentModel;
let currentModelClones = [];

let currentModelTablets = [];
let otherModels = {};
let otherModels_setings = {};
let movable_settings_index = 0;
let control_settings_index_global = 0;
let userData = {};
let currentModelLoaded = false;
let loaded = {
    color: false,
};
window.countOfLoadingChanges = 0;
let countOfLoadingPreColorChanges = 0;
let color_changes = [];
let apply_all_color_changes = () => {
    while (color_changes.length){
        color_changes.shift()()
            .then(() => {
                countOfLoadingChanges--;
            });
    }
};

let url;
let old_cloneCount = 0;

let modelIndex;
let orbitControls0 = {};

let models_loaded = 0;
let models_parts_load = {};
let spot1;
let itemsTotalLast = 0;
let itemsLoadedLast = 0;
let progressLast = 0;
let animateTimeout = 0;
let composer, renderPass, saoPass, taaRenderPass;
let copyPass;

let hdr_loading = hdr_settings.addToScene;

let hdr_progress = 0;


let loader = new GLTFLoader();

const dracoLoader = new DRACOLoader();

// must be lights_multiplier + env_multiplier = 2
/**
 * lights can castShadow
 * */
let lights_multiplier = 1
/**
 * envMap can't castShadow
 * */
let env_multiplier = 1
let lights_intensity = {
    amb: 0.09 * (lights_multiplier),
    hem: 0.01 * (lights_multiplier),
    dir1: 0.80 * (lights_multiplier),
    dir2: 1 * (lights_multiplier),
    spot1: 0.7 * (lights_multiplier), // spot from front side
    spot2: 0.2 * (lights_multiplier),
    rect1: 0.1 * (lights_multiplier),
    rect2: 0.5 * (lights_multiplier),
    rect3: 0.1 * (lights_multiplier),
    rect32: 0.3 * (lights_multiplier),
    rect4: 1 * (lights_multiplier),
    rect5: 3 * (lights_multiplier),
    rect6: 2 * (lights_multiplier),
    rect7: 0.8 * (lights_multiplier),
    rect8: 0.5 * (lights_multiplier),
}
let AmbLight;
let HemisphereLight;
let light;
let light2;
let spotLight1;
let spotLightHelper
let model_progress = 0;

let loadStartTime = performance.now();



// загрузка окружения(то что оражается) и добавление на сцену
function HDR_envmap(hdrState) {
    /*
            hdr_settings: {
                addToScene: true,
                url: '/images/machine_shop_01_1k.hdr',
                addAsBackground: true,//show in background
                addAsEnvironment: true,//show in reflection on object in scene
            }
    */
    if (hdrState.addToScene) {
        new RGBELoader()
            .load(hdrState.url, function (texture, texData) {
                    // // //log(texData);
                    // // //log(texData.header);
                    // // //log(texData.data);
                    // // //log(texData.data.length);

                    // черно белая текстура вместо цветной
                    for (let i = 0; i < (texData.data.length / 4); i++) {

                        const stride = i * 4;

                        const r = texData.data[stride];
                        const g = texData.data[stride + 1];
                        const b = texData.data[stride + 2];

                        texData.data[stride] = Math.floor(((r + g + b) / 3));
                        texData.data[stride + 1] = Math.floor(((r + g + b) / 3));
                        texData.data[stride + 2] = Math.floor(((r + g + b) / 3));
                    }

                    // // //log(texData.data);

                    texture.mapping = THREE.EquirectangularReflectionMapping
                    if (hdrState.addAsBackground) {
                        scene.background = texture;

                    }
                    if (hdrState.addAsEnvironment) {
                        scene.environment = texture;

                    }
                },
                function (xhr) {

                    hdr_progress = xhr.loaded / xhr.total;
                    // updateProgressBar(Math.floor( (model_progress * (hdr_loading?80:100)+(hdr_progress *(hdr_loading? 20:0)))));
                    if (xhr.loaded / xhr.total === 1) {
                        // // //log( 'Loading hdr complete!');

                    }
                    // // //log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' );

                });
    }
}


let progressBarOnScreen;
let progressDiv, elWith3dIco;
let progressBarDiv;

// показ экрна загрузки
function showProgressBar() {

    progressBarOnScreen = true;
    progressDiv.style.width = get_size_of_3d_preview().width + 'px';
    progressDiv.style.display = '';
    progressBarDiv.style.width = '';

    // // //log( progressBarDiv );

}

// обновление экрна загрузки
let savedFraction = 0
function updateProgressBar(fraction) {
// console.log('updateProgressBar', fraction)
    // progressDiv.innerText = 'Loading... ' + Math.round( fraction, 2 ) + '%';
    savedFraction = fraction
    setTimeout(function () {
        if (savedFraction === 100) {
            hideProgressBar()
        }
    }, 400)

}

// скрытие экрна загрузки
function hideProgressBar() {

    progressBarOnScreen = false;
    progressDiv.style.display = 'none';
    progressBarDiv.style.width = '';
    if (models_loaded === 1) {
        elWith3dIco.style.display = '';
    }

}


function controlsReset() {
    orbitControls.object = camera;
    orbitControls.reset();

    Object.keys(orbitControls0).map(function (objectKey) {
        // // //log(orbitControls[objectKey]);
        orbitControls[objectKey] = orbitControls0[objectKey];
        // // //log(orbitControls0[objectKey]);
    });
    orbitControls0 = {};
}
function sceneReset() {
    orbitControls.object = camera;
    orbitControls.reset();

    Object.keys(orbitControls0).map(function (objectKey) {
        // // //log(orbitControls[objectKey]);
        orbitControls[objectKey] = orbitControls0[objectKey];
        // // //log(orbitControls0[objectKey]);
    });
    orbitControls0 = {};
}
let modelParts = []

function unLoadModelParts() {
    modelParts.forEach(function (modelPart){
        console.log('remove')
        scene.remove(modelPart);
    });
    modelParts.splice(0)
}

function unLoadModelPart(id) {
    models_parts_load[id] = false
    console.log(id, models_parts_load)
    modelParts
        .filter(element => element.userData.partId === id)
        .forEach(elementToRemove => {
            let index = modelParts.indexOf(elementToRemove)
            if (index < 0) {
                return
            }

            modelParts.splice(index, 1)
            scene.remove(elementToRemove)
        })
}


function loadModelParts(settingsJSON) {
    let counter = models_loaded

    let settings = [];
    try {
        settings = JSON.parse(settingsJSON);

    }catch (e){
        console.error(e);
    }
    if(Array.isArray(settings)){
        model_settings = settings
    }

    let loadPartPromises = [];

    settings.forEach(function (part_settings) {

        if(part_settings['isInSceneByDefault'] === '0'){
            return;
        }
        if(counter !== models_loaded){
            return
        }
        let loadPartPromise = loadModelPart(part_settings['id'])

        loadPartPromises.push(loadPartPromise);
    });

    return Promise.all(loadPartPromises)

}

async function loadModelPart(id){
    models_parts_load[id] = true
    console.log(id, models_parts_load)
    let counter = models_loaded

    let loaded = modelParts.some(element => element.userData.partId === id)
    if(loaded){
        return
    }

    let part_settings = model_settings.find(element => element.id === id)
    if(part_settings == null){
        return
    }
    console.log(part_settings)
    let part_id = part_settings['id'];
    let newPos = new THREE.Vector3(0, 0, 0, 'XYZ');
    let newRotation = new THREE.Euler(0, 0, 0, 'XYZ');
    let newScaleVector = new THREE.Vector3(0, 0, 0, 'XYZ');
    let posX = part_settings['posX'];
    let posY = part_settings['posY'];
    let posZ = part_settings['posZ'];
    let rotationX = part_settings['rotationX'];
    let rotationY = part_settings['rotationY'];
    let rotationZ = part_settings['rotationZ'];
    let scale = part_settings['scale'];
    let indexesOfMeshes = part_settings['indexesOfMeshes'];
    let imageExt = part_settings['imageExt'];
    if(posX) {
        newPos.x = posX
    }
    if(posY) {
        newPos.y = posY
    }
    if(posZ) {
        newPos.z = posZ
    }
    if(rotationX) {
        newRotation.x = rotationX
    }
    if(rotationY) {
        newRotation.y = rotationY
    }
    if(rotationZ) {
        newRotation.z = rotationZ
    }
    if(!scale) {
        scale = 1
    }

    newScaleVector.x = scale;
    newScaleVector.y = scale;
    newScaleVector.z = scale;

    let product_id = document.querySelector('#product_id').value;
    let item_id = document.querySelector('#item_id').value;

    let baseUrl = `/models/${product_id}/${item_id}/${part_id}/`
    let filename = `model.glb`
    let url = `${baseUrl}${filename}`

    try{
        let gltf = await loader.loadAsync(url)
        console.log(id, models_parts_load)
        if(!models_parts_load[id]){
            return
        }
        console.log(gltf)
        {

            if(counter !== models_loaded){
                return
            }

            let modelPart = gltf.scene;
            modelPart.userData.partId = part_id
            modelPart.traverse(function (node) {
                if (node.isMesh || node.isLight) {
                    node.castShadow = true;
                    node.receiveShadow = true;
                    if (node.material.map) {
                        node.material.map.anisotropy = renderer.capabilities.getMaxAnisotropy();
                    }
                }
            });
            console.log(part_settings['cloneSettings'])
            let cloneSettings = [];
            modelPart.userData.clones = []
            try {
                cloneSettings = JSON.parse(part_settings['cloneSettings'])
                if (Array.isArray(cloneSettings)){
                    modelPart.userData.clones = cloneSettings
                }
                if (!Array.isArray(cloneSettings)){
                    cloneSettings = []
                }
            } catch (e) {
                console.error(e)
            }
            {
                cloneSettings.forEach((settings, index) => {
                    let newPos = new THREE.Vector3(0, 0, 0, 'XYZ');
                    let newRotation = new THREE.Euler(0, 0, 0, 'XYZ');
                    let newScaleVector = new THREE.Vector3(0, 0, 0, 'XYZ');
                    let posX = settings['posX'];
                    let posY = settings['posY'];
                    let posZ = settings['posZ'];
                    let rotationX = settings['rotationX'];
                    let rotationY = settings['rotationY'];
                    let rotationZ = settings['rotationZ'];
                    let scale = settings['scale'];
                    if(posX) {
                        newPos.x = posX
                    }
                    if(posY) {
                        newPos.y = posY
                    }
                    if(posZ) {
                        newPos.z = posZ
                    }
                    if(rotationX) {
                        newRotation.x = rotationX
                    }
                    if(rotationY) {
                        newRotation.y = rotationY
                    }
                    if(rotationZ) {
                        newRotation.z = rotationZ
                    }
                    if(!scale) {
                        scale = 1
                    }

                    newScaleVector.x = scale;
                    newScaleVector.y = scale;
                    newScaleVector.z = scale;

                    let clonePart = modelPart.clone()
                    clonePart.userData.isClone = true
                    modelParts.push(clonePart);
                    modelPart.userData.clones.push(clonePart);
                    scene.add(clonePart);

                    clonePart.position.copy(newPos);
                    clonePart.rotation.copy(newRotation);
                    clonePart.scale.copy(newScaleVector);
                })
            }
            scene.add(modelPart);
            modelParts.push(modelPart);

            modelPart.userData.originalMaterial = {}
            modelPart.userData.currentColor = {}
            modelPart.userData.currentImage = {}
            modelPart.userData.currentImageVersions = {}
            modelPart.userData.counterImageVersions = {}
            let i = 0
            modelPart.traverse(function (node) {
                if (node.isMesh || node.isLight) {
                    node.castShadow = true;
                    node.receiveShadow = true;
                    if (node.material.map) {
                        node.material.map.anisotropy = renderer.capabilities.getMaxAnisotropy();
                    }
                }
                if (node.isMesh) {
                    // console.log(node.material)
                    // node.material.shadowSide = THREE.DoubleSide
                    // node.material = new THREE.ShadowMaterial({color: 0, transparent : false})

                    // node.material.color = new THREE.Color( 0x808080 );
                    node.material.envMapIntensity = env_multiplier;
                    node.material.needsUpdate = true
                    progressiveSurfacemap.addObjectsToLightMap( lightmapObjects );
                    modelPart.userData.originalMaterial[i] = node.material.clone()
                    modelPart.userData.currentColor[i] = 0x808080;

                    if(modelPart.userData.originalMaterial[i].map != null && modelPart.userData.originalMaterial[i].map.image != null) {
                        modelPart.userData.currentImage[i] = modelPart.userData.originalMaterial[i].map.image;
                    }

                    modelPart.userData.counterImageVersions[i] = {
                        color: 0,
                        texture: 0,
                        nm: 0,
                        occ: 0,
                    };
                    modelPart.userData.currentImageVersions[i] = {
                        color: 0,
                        texture: 0,
                        nm: 0,
                        occ: 0,
                    };

                    ++i;
                }
            });
            modelPart.userData.indexesOfMeshes = indexesOfMeshes
            modelPart.userData.imageExt = imageExt
            modelPart.userData.partId = part_id
            modelPart.userData.baseUrl = baseUrl
            modelPart.userData.filename = filename

            modelPart.position.copy(newPos);
            modelPart.rotation.copy(newRotation);
            modelPart.scale.copy(newScaleVector);

        }
        return true
    }catch(e){
        console.error(e);
    }

}

function initScene(index, customUrl, cameraCenter, counter_value, control_settings_index = 0, options = {}) {
    let optionsFromParams = Object.assign({
        cloneCount: 0,
        otherModels: {},
        movable_settings_index: 0,
        camera_pos:'',
    },options)
    movable_settings_index = optionsFromParams.movable_settings_index
    // //log('movable_settings_index', movable_settings_index)
    control_settings_index_global = control_settings_index
    if(optionsFromParams.otherModels != null && typeof optionsFromParams.otherModels === 'string' && optionsFromParams.otherModels.length < 2){
        optionsFromParams.otherModels = '{}'
    }
    currentModelLoaded = false;

    const is_need_add_terrain = [1].indexOf(control_settings_index) === -1;
    if (is_need_add_terrain) {
        scene.add(terrain);
    }
    // //  //log('GLTF LOAD============' + cameraCenter);

    modelIndex = index;
    orbitControls0 = {};

    if (typeof control_settings[control_settings_index] !== 'undefined') {
        sceneInfo[modelIndex]['control_settings'] = control_settings[control_settings_index];
    } else {
        sceneInfo[modelIndex]['control_settings'] = control_settings[0];
    }

    if (typeof sceneInfo[modelIndex]['control_settings'] !== 'undefined') {
        Object.keys(sceneInfo[modelIndex]['control_settings']).map(function (objectKey) {
            // // //log(orbitControls[objectKey]);
            orbitControls0[objectKey] = orbitControls[objectKey];
            orbitControls[objectKey] = sceneInfo[modelIndex].control_settings[objectKey];
            // // //log(sceneInfo[modelIndex].control_settings[objectKey]);
        });
    }
// //  //log(orbitControls0);
    // url = sceneInfo[modelIndex].url;//.replace(/%s/g, state.extension);
    let is_new_url = customUrl !== url;
    url = customUrl;


                //     // //log(modelIndex);
                //     // //log(index);
                //     // //log(currentModel);
                // //    //log(url);
                    //log('GLTF LOAD', optionsFromParams.cloneCount, old_cloneCount);
                    //log(optionsFromParams);

                if (typeof currentModel === 'undefined' || (counter_value === models_loaded)|| optionsFromParams.cloneCount !== old_cloneCount) {
                    unLoadCurrentModel({needUnLoadTerrain:false});


                    if ([3].indexOf(control_settings_index) !== -1) {
                        // Mouse buttons
                        orbitControls.mouseButtons = {LEFT: THREE.MOUSE.DOLLY, MIDDLE: THREE.MOUSE.DOLLY, RIGHT: THREE.MOUSE.DOLLY};

                        // Touch fingers
                        orbitControls.touches = {ONE: THREE.TOUCH.DOLLY_PAN, TWO: THREE.TOUCH.DOLLY_PAN};

                    } else {
                        // Mouse buttons
                        orbitControls.mouseButtons = {LEFT: THREE.MOUSE.ROTATE, MIDDLE: THREE.MOUSE.DOLLY, RIGHT: THREE.MOUSE.ROTATE};

                        // Touch fingers
                        orbitControls.touches = {ONE: THREE.TOUCH.ROTATE, TWO: THREE.TOUCH.ROTATE};

                    }


                    camera.position.copy(sceneInfo[modelIndex].cameraPos)
                    if ([3].indexOf(control_settings_index) !== -1) {
                        camera.position.x = 0
                    }
                    if (typeof optionsFromParams.camera_pos === 'string' && optionsFromParams.camera_pos.length > 0) {
                        let s = optionsFromParams.camera_pos.split(',');
                        if (s.length === 3) {
                            // //  //log('cameraCenter LOAD============' + cameraCenter);
                            camera.position.copy(new THREE.Vector3(parseFloat(s[0]), parseFloat(s[1]), parseFloat(s[2])));
                            // console.info(parseFloat(s[0]), parseFloat(s[1]), parseFloat(s[2]));
                        }
                    }

                    if (typeof cameraCenter !== 'undefined' && cameraCenter.length > 0) {
                        let s = cameraCenter.split(',');
                        if (s.length === 3) {
                            // //  //log('cameraCenter LOAD============' + cameraCenter);
                            orbitControls.target.copy(new THREE.Vector3(parseFloat(s[0]), parseFloat(s[1]), parseFloat(s[2])));
                            // //console.info(parseFloat(s[0]), parseFloat(s[1]), parseFloat(s[2]));
                        } else {
                            // //  //log('cameraCenter1 LOAD============' + cameraCenter);
                            orbitControls.target.copy(new THREE.Vector3(0, 0, 0),);
                        }
                    } else {
                        // // //log('cameraCenter2 LOAD============' + cameraCenter);
                        orbitControls.target.copy(new THREE.Vector3(0, 0, 0),);
                    }

                    load_spherical
                        .setFromVector3(
                            new THREE.Vector3()
                                .copy(orbitControls.object.position)
                                .sub(orbitControls.target)
                                .applyQuaternion(
                                    new THREE.Quaternion()
                                        .setFromUnitVectors(orbitControls.object.up, new THREE.Vector3(0, 1, 0))
                                )
                                .clone());



                    if (sceneInfo[modelIndex].hdr_settings) {
                        // scene.background = new THREE.Color(0xFFFFFF);
                    } else {
                        scene.background = new THREE.Color(0xFFFFFF);
                    }







                }

    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;


    return Promise.resolve();
    //changeCurrentModelsTexture(1, "models/longboardLow_Wheels_BaseColor.png");
    //  changeCurrentModelsTexture(0, "models/longboardLow_Desk_BaseColor.png");
}

function unLoadCurrentModel(options = {} ) {
    let optionsFromParams = Object.assign({
        needUnLoadTerrain: true
    }, options)
     //log('unLoadCurrentModel');
     //log(currentModel);

    let counter_value = models_loaded;
    // let optionsFromParams = Object.assign({
    //     countOfmodel: 0,
    //     code: '',
    // }, options)

    let code = optionsFromParams.code;
    let countOfmodel = optionsFromParams.countOfmodel;
    if (!Array.isArray(otherModels[code])) otherModels[code] = [];
    let i_max = -1
    //log('addOtherModels==');
    //log(otherModels[code]);
    //log('addOtherModels--');
    otherModels[code].forEach(
        (v, i) => {
            if(i >= countOfmodel){
                scene.remove(v);
                return;
            }
            if (scene.children.indexOf(v) !== -1){
                i_max = i;
            }
        }
    );


    // load_spherical = new THREE.Spherical();

    scene.remove(currentModel);

    currentModelClones.forEach((v) => {
        scene.remove(v);
    });

    //log('-----------------');
    //log(currentModelTablets);
    //log('------------------');

    currentModelTablets.forEach((v)=>{
        scene.remove(v);
    });

    currentModelClones = []
    Object.keys(otherModels).forEach((key)=>{
        otherModels[key].forEach((v)=>{
            scene.remove(v);


        });

    });
    otherModels = {}

    if (typeof terrain !== 'undefined' && optionsFromParams.needUnLoadTerrain) {
        scene.remove(terrain);
    }
    scene.background = new THREE.Color(0xFFFFFF);


}

let changeModelBtn = document.getElementById('changeModel');
changeModelBtn.addEventListener('click', function (e) {
    let url = changeModelBtn.getAttribute("data-url");
    let camera_center = changeModelBtn.getAttribute("data-camera");
    let control_settings_index = Number(changeModelBtn.getAttribute("data-control_settings_index"));
    let movable_settings_index = Number(changeModelBtn.getAttribute("data-movable_settings_index"));
    //log('movable_settings_index', movable_settings_index)
    let clone_count = Number(changeModelBtn.getAttribute("data-clone_count"));
    let other_models = changeModelBtn.getAttribute("data-other_models");
    let $3d_models = changeModelBtn.getAttribute("data-3d_models");
    let camera_pos = changeModelBtn.getAttribute("data-camera_pos");
    let options = {}
    if(clone_count > 0) {
        options.cloneCount = clone_count
    }
    if(camera_pos != null && camera_pos.length > 0) {
        options.camera_pos = camera_pos
    }
    if(other_models !== '' && other_models != null) {
        options.otherModels = JSON.parse(other_models)
    }
    if($3d_models !== '' && $3d_models != null) {
        options['3d_models'] = JSON.parse($3d_models)
    }

    let attrRotateMeshesData = changeModelBtn.getAttribute("data-rotateMeshesData");
    let rotateMeshesData
    if(attrRotateMeshesData!=null){
        rotateMeshesData = JSON.parse(attrRotateMeshesData);

    }
    changeModelBtn.removeAttribute("data-rotateMeshesData");
    changeModelBtn.setAttribute("data-clone_count", 0);
    changeModelBtn.setAttribute("data-other_models", '');
    changeModelBtn.setAttribute("data-3d_models", '');
    // //log(changeModelBtn);

    control_settings_index = control_settings_index ? control_settings_index : 0;
    movable_settings_index = movable_settings_index ? movable_settings_index : 0;
    options['movable_settings_index'] = movable_settings_index
    // //log('movable_settings_index', movable_settings_index)
    // //log(control_settings_index);
    // //log(url);
    changeModel(0, url, camera_center, control_settings_index, options).then(() => {
        if (rotateMeshesData != null) {
            clearTimeout(animateTimeout)
            animateTimeout = setTimeout(() => {
                rotateMeshes(rotateMeshesData.deg, rotateMeshesData.axis, JSON.parse(rotateMeshesData.indexes_of_meshes))
            }, 1000)

        }
    }).catch(console.error);
});
let resetOrbitControlAndMeshesBtn = document.getElementById('resetOrbitControlAndMeshes');
resetOrbitControlAndMeshesBtn.addEventListener('click', function (e) {

    let indexOfMesh_not_reset = JSON.parse(resetOrbitControlAndMeshesBtn.getAttribute("data-indexes_of_meshes__not_reset"));

    resetOrbitControlAndMeshesBtn.setAttribute("data-indexes_of_meshes__not_reset", '[]');


    rotateModel(0, 0, 30, 0);

});

let loadModelPartBtn = document.getElementById('loadModelPart');
loadModelPartBtn.addEventListener('click', async function (e) {
    let id = JSON.parse(loadModelPartBtn.getAttribute("data-id"));

    countOfLoadingChanges++

    try {
        updateProgressBar(0);
        showProgressBar();

        let loaded_correctly = await loadModelPart(id)

        if(loaded_correctly){
            let models = modelParts.filter((m) => m?.userData?.partId === id)
            console.trace(models)
            let processAllChangesForColor = Object.entries(changesCallBacksForColor).sort().map(([,callback]) => {
                return callback(models).catch(console.error);
            });
            await Promise.all(processAllChangesForColor)

            let processAllChanges = Object.entries(changesCallBacks).sort().map(([key,callback]) => {
                return callback(models).catch(console.error);
            });
            await Promise.all(processAllChanges)
        }
    } catch (e) {
        console.log(e)
    }
    countOfLoadingChanges--
});
let unLoadModelPartBtn = document.getElementById('unLoadModelPart');
unLoadModelPartBtn.addEventListener('click', async function (e) {
    let id = JSON.parse(unLoadModelPartBtn.getAttribute("data-id"));

    countOfLoadingChanges++

    try {
        if(models_parts_load[id]){
            updateProgressBar(0);
            showProgressBar();
            await unLoadModelPart(id)
        }
    } catch (e) {
        console.log(e)
    }

    countOfLoadingChanges--
});

let rotateModelBtn = document.getElementById('rotateModel');
rotateModelBtn.addEventListener('click', function (e) {
    console.log('rotateModel')
    // let hex  = '#' + rotateModelBtn.getAttribute("data-hex");
    let theta_angle = parseInt(rotateModelBtn.getAttribute("data-rotate_angle"));
    let phi_angle = 0;
    // //log(currentModelLoaded);
    if (!currentModelLoaded) {
        onloadCallBacks['rotateModel'] = (function () {
            return rotateModel.apply(this, [phi_angle, theta_angle, 30]);
        });

    } else {

        rotateModel(phi_angle, theta_angle, 30);
    }

});

let changeColorBtn = document.getElementById('changeColor');
changeColorBtn.addEventListener('click', function (e) {
    //let url  = changeModelBtn.getAttribute("data-url");
    // let center  = changeModelBtn.getAttribute("data-center");
    let hex = '#' + changeColorBtn.getAttribute("data-hex");

    // //log('change_map 1' + changeColorBtn.getAttribute("data-change_map") );


    let change_map = changeColorBtn.getAttribute("data-change_map") === 'true';
    let cs = changeColorBtn.getAttribute("data-cs");

    let otherModelsIndexesOfMesh = {};
    changeColorBtn.setAttribute("data-index_of_mesh", '');
    changeColorBtn.setAttribute("data-hex", '');
    changeColorBtn.setAttribute("data-change_map", '');
    changeColorBtn.setAttribute("data-cs", '');

    //  //log(indexOfMesh, hex, changeColorBtn.getAttribute("data-hex"));
    // //log(changeColorBtn);
    // //log('changeColor 1' + change_map);
// if(change_map){
//     debugger
// }
  //  //log(hex, 'currentModelLoaded')
  //   onloadCallBacksForColor['changeModelsColor_cs' + cs] =
    let apply_color_function = (async function () {
        return changeModelsColor.apply(this, [cs, hex]);
    })
    changesCallBacksForColor['changeModelsColor_cs' + cs] = (async function (models) {
        console.error(models)
        return changeModelsColor.apply(this, [cs, hex, models]);
    });
    if (!currentModelLoaded) {
        onloadCallBacksForColor['changeModelsColor_cs' + cs] = apply_color_function;
    } else {
        countOfLoadingChanges++

        if(countOfLoadingPreColorChanges > 0){
            color_changes.push(apply_color_function)
        }

        if (!countOfLoadingPreColorChanges) {
            apply_color_function()
                .then(() => {
                    countOfLoadingChanges--;
                });
        }
        // console.log('countOfLoadingChanges', countOfLoadingChanges)
        updateProgressBar(0);
        showProgressBar();

    }
});


let changeModelsTextureBtn = document.getElementById('changeCurrentModelsTexture');
changeModelsTextureBtn.addEventListener('click', function (e) {
    // console.log('changeModelsTextureBtn')
    let other_map = changeModelsTextureBtn.getAttribute("data-other_map");
    let cs = changeModelsTextureBtn.getAttribute("data-cs");
    let code = changeModelsTextureBtn.getAttribute("data-code");
    let applyColor = changeModelsTextureBtn.getAttribute("data-applyColor") === '1';



    changeModelsTextureBtn.setAttribute("data-cs", '');
    changeModelsTextureBtn.setAttribute("data-code", '');
    changeModelsTextureBtn.setAttribute("data-other_map", '');
    changeModelsTextureBtn.setAttribute("data-applyColor", '');
    //   // //log(indexOfMesh);
    //   // //log(changeColorBtn);
    // //   //log(url);
    //    //log('changeCurrentModelsTexture 1' + hex);
    // console.log('changeModelsTexture', cs, other_map, code)
    changesCallBacks['changeModelsTexture_cs' + cs + '_indexOfMesh' + other_map] = (async function (models) {
        return changeModelsTexture.apply(this, [cs, other_map, code, applyColor, models]);
    });
    if (!currentModelLoaded) {
        onloadCallBacks['changeModelsTexture_cs' + cs + '_indexOfMesh' + other_map] = (async function () {
            return changeModelsTexture.apply(this, [cs, other_map, code, applyColor]);
        });

    } else {
        countOfLoadingChanges++
        countOfLoadingPreColorChanges++
        // console.log('countOfLoadingChanges', countOfLoadingChanges)

        updateProgressBar(0);
        showProgressBar();
        changeModelsTexture(cs, other_map, code,applyColor)
            .then(function () {
                countOfLoadingChanges--
                countOfLoadingPreColorChanges--
                if(!countOfLoadingPreColorChanges){
                    apply_all_color_changes()
                }
            });
    }
});
let changeModelsTextureCustomBtn = document.getElementById('changeModelsTextureCustom');
changeModelsTextureCustomBtn.addEventListener('click', function (e) {
    // console.log('changeModelsTextureBtn')
    let other_map = changeModelsTextureCustomBtn.getAttribute("data-other_map");
    let cs = changeModelsTextureCustomBtn.getAttribute("data-cs");
    let url = changeModelsTextureCustomBtn.getAttribute("data-url");
    let x = parseFloat(changeModelsTextureCustomBtn.getAttribute("data-repeat_x"));
    let y = parseFloat(changeModelsTextureCustomBtn.getAttribute("data-repeat_y"));
    let is_need_mirror = changeModelsTextureCustomBtn.getAttribute("data-is_need_mirror") === 'true';
    let rotate = changeModelsTextureCustomBtn.getAttribute("data-rotate") === 'true';
    if(x == null) x = 1;
    if(y == null) y = 1;
    if(url == null) url = '';
    if(cs == null) cs = '';

    changeModelsTextureCustomBtn.setAttribute("data-cs", '');
    changeModelsTextureCustomBtn.setAttribute("data-url", '');
    changeModelsTextureCustomBtn.setAttribute("data-other_map", '');
    changeModelsTextureCustomBtn.setAttribute("data-repeat_x", '');
    changeModelsTextureCustomBtn.setAttribute("data-repeat_y", '');
    changeModelsTextureCustomBtn.setAttribute("data-is_need_mirror", 'true');
    changeModelsTextureCustomBtn.setAttribute("data-rotate", 'false');

    changesCallBacks['changeModelsTextureCustom_cs' + cs + '_indexOfMesh' + other_map] = (async function (models) {
        return changeModelsTextureCustom.apply(this, [cs, other_map, url, {x,y,}, rotate, is_need_mirror, models]);
    });

    if (!currentModelLoaded) {
        onloadCallBacks['changeModelsTextureCustom_cs' + cs + '_indexOfMesh' + other_map] = (async function () {
            return changeModelsTextureCustom.apply(this, [cs, other_map, url, {x,y,}, rotate, is_need_mirror]);
        });

    } else {
        countOfLoadingChanges++
        countOfLoadingPreColorChanges++
        // console.log('countOfLoadingChanges', countOfLoadingChanges)

        updateProgressBar(0);
        showProgressBar();
        changeModelsTextureCustom(cs, other_map, url,{x,y,}, rotate, is_need_mirror)
            .then(function () {
                countOfLoadingChanges--
                countOfLoadingPreColorChanges--
                if(!countOfLoadingPreColorChanges){
                    apply_all_color_changes()
                }

            });
    }
});
let rotateLoopAnimationBtn = document.getElementById('rotateLoopAnimation');
rotateLoopAnimationBtn.addEventListener('click', function (e) {

    let set_playing = rotateLoopAnimationBtn.getAttribute("data-set_playing") === 'true';
    let is_playing = setRotateloopAnimation(set_playing)
    rotateLoopAnimationBtn.setAttribute("data-is_playing", is_playing);

});

let rotateMeshesBtn = document.getElementById('rotateMeshes');
rotateMeshesBtn.addEventListener('click', function (e) {

    let indexes_of_meshes = JSON.parse(rotateMeshesBtn.getAttribute("data-indexes_of_meshes"));// array of indexes
    let deg = Number(rotateMeshesBtn.getAttribute("data-deg"));
    let axis = rotateMeshesBtn.getAttribute("data-axis");// 'x' or 'y' or 'z'
    rotateMeshesBtn.setAttribute("data-indexes_of_meshes", '[]')
    rotateMeshesBtn.setAttribute("data-deg", '0')
    rotateMeshesBtn.setAttribute("data-axis", 'y')

    rotateMeshes(deg, axis, indexes_of_meshes)
});

let changeLightningBtn = document.getElementById('changeLightning');
changeLightningBtn.addEventListener('click', function (e) {

    let count = Number(changeLightningBtn.getAttribute("data-count"));
    let options = changeLightningBtn.getAttribute("data-options");// 'x' or 'y' or 'z'
    changeLightningBtn.setAttribute("data-count", '0');
    changeLightningBtn.setAttribute("data-options", '{}');

   // changeLightning(count, options);
});


// возобновление сцены и потом добавление модели
function changeModel(index, url_for_load, center, control_settings_index, options = {}) {
    let optionsFromParams = Object.assign({
        cloneCount: 0,
        otherModels: {},
        '3d_models': [],
        camera_pos: '',
        movable_settings_index: 0
    },options)
    if (typeof currentModel === 'undefined' || url !== url_for_load || optionsFromParams.cloneCount != null) {
        clearTimeout(animateTimeout);
    }

    // //log('788 fnc changeModel', index, url_for_load, center );
    // //log(currentModel);
    // //log(url);
    currentModelLoaded = false;


    loadStartTime = performance.now();
// // //log(typeof currentModel === 'undefined');

// //log(url);
// // //log(url_for_load);
// // //log(url !== url_for_load);


    // }
    if (typeof currentModel === 'undefined' || url !== url_for_load || optionsFromParams.cloneCount != null) {
        let need_to_load = ++models_loaded;
        unLoadCurrentModel();
        unLoadModelParts()
        controlsReset();

        updateProgressBar(0);
        showProgressBar();

        onloadCallBacks = {};
        // // //log('go loadModel');


        // console.log(`/models/model.glb`)

        async function load_changes() {
            try{

                {
                    let onloadLength = Object.entries(onloadCallBacks).length;
                    let loads = []
                    Object.entries(onloadCallBacks).sort().forEach(([, callback]) => {
                        loads.push(callback());
                    });
                    onloadCallBacks = {}
                    await Promise.all(loads)
                        .catch((e) => {
                            throw e
                        })
                }
                {
                    let onloadLength = Object.entries(onloadCallBacksForColor).length;
                    let loads = []
                    Object.entries(onloadCallBacksForColor).sort().forEach(([, callback]) => {
                        loads.push(callback());
                    });
                    onloadCallBacksForColor = {}
                    await Promise.all(loads)
                        .catch((e) => {
                            throw e
                        })
                }
                let color_loaded = Object.entries(onloadCallBacksForColor).length === 0;
                let textures_loaded = Object.entries(onloadCallBacks).length === 0;
                if (!color_loaded || !textures_loaded){
                    await load_changes()
                }
            }catch (e){
                console.error(e)
            }
        }
        return Promise.all([
            loadModelParts(optionsFromParams['3d_models'], models_loaded),
            initScene(index, url_for_load, center, models_loaded, control_settings_index, options),
        ])
            .then(()=>{ return load_changes()})
            .then(function () {
                if (need_to_load === models_loaded) {
                    currentModelLoaded = true;
                }

            })

    }  else {

        url = url_for_load;
        return Promise.resolve()
    }





}


// наложение цвета с возможность убрать текстуру
// должно быть вызвана до changeModelsTexture или заменит новую текстуру

/**
 загруска и установка новой текстуры
 indexesOfMesh:
 to apply for all meshes
 indexesOfMesh -> 'all'

 to apply for multiple meshes
 indexesOfMesh -> {'some value':index,'some value2':'index2',..} or [index, 'index2',..]

 to apply for one mesh
 indexesOfMesh -> 'index' or index

 url:
 чтоб загрузить текстуру по сылке используем переменую url


 other_map:
 если узаказан параметр 'occlusionRoughnessMetallic'  тогда обновляем occlusion

 */
function changeModelsTexture(cs = '', other_map = '', code = '', applyColor = false, otherModels = []) {
    console.trace('texture', cs, other_map, code, applyColor, otherModels, otherModels?.map?.(element => element.userData.partId))
    let models = modelParts;
    if (Array.isArray(otherModels) && otherModels.length) {
        models = otherModels;
    }
    let textureLoader = new THREE.TextureLoader();
    let loadingTextureForModels = [];
    let applyingTextureForModels = [];
    let cloneParts = {};
    models.forEach(function (modelPart) {
        if (modelPart.userData.isClone) {
            return;
        }

        let coloredImages = {};

        let imageExt = findOutImageExt(cs, modelPart.userData.imageExt);
        if (typeof imageExt === 'undefined') {
            imageExt = 'jpg';
        }
        let meshes = [];

        modelPart.traverse(function (child) {
            if (child instanceof THREE.Mesh) {
                meshes.push(child);
            }
        });
        let indexOfMesh = findOutIndexOfMeshes(cs, modelPart.userData.indexesOfMeshes);

        let checkIfYouNeedMeshWithThisIndex = getCheckerOfIndexes(indexOfMesh);

        let url = `${modelPart.userData.baseUrl}${code}.${imageExt}`;
        let imageVersion = {};// for this img
        let colorVersion = {};// for this img
        meshes.forEach(function (child, i) {
            if (checkIfYouNeedMeshWithThisIndex(i)) {
                if (other_map === 'occlusionRoughnessMetallic') {
                    imageVersion[i] = ++modelPart.userData.counterImageVersions[i].occ;
                    imageVersion.name = 'occ';
                } else if (other_map === 'normal') {
                    imageVersion[i] = ++modelPart.userData.counterImageVersions[i].nm;
                    imageVersion.name = 'nm';
                } else {
                    imageVersion[i] = ++modelPart.userData.counterImageVersions[i].texture;
                    imageVersion.name = 'texture';
                    colorVersion[i] = modelPart.userData.counterImageVersions[i].color;
                }

            }
        });
        let loadingTexture =
            new Promise(function (resolve, reject) {

                let needLoadTexture = meshes.some((e, i) => checkIfYouNeedMeshWithThisIndex(i));
                if (!needLoadTexture) {
                    resolve();
                    return;
                }
                if (code === '') {
                    resolve();
                    return;
                }
                textureLoader.load(url, function (newTexture) {
                        newTexture.colorSpace = THREE.SRGBColorSpace;
                        newTexture.flipY = false;
                        newTexture.needsUpdate = true;
                        newTexture.anisotropy = renderer.capabilities.getMaxAnisotropy();
                        resolve(newTexture);

                    },
                    // onProgress callback currently not supported
                    undefined,
                    function (err) {
                        resolve();
                    });
            })
                .then(function (texture) {
                    meshes.forEach(function (child, i) {
                        if (checkIfYouNeedMeshWithThisIndex(i)) {
                            let colorNumber = modelPart.userData.currentColor[i];
                            if (colorNumber == null) {
                                colorNumber = 0x808080;
                            }
                            if (coloredImages[colorNumber] == null) {

                                if (other_map === 'occlusionRoughnessMetallic') {

                                    coloredImages[colorNumber] = Promise.resolve(texture);
                                } else if (other_map === 'normal') {

                                    coloredImages[colorNumber] = Promise.resolve(texture);
                                } else {

                                    let image;

                                    if (texture == null && code !== '') {

                                        let originalM = modelPart.userData.originalMaterial[i];
                                        texture = originalM.map;
                                    }
                                    if (texture == null || texture.image == null) {

                                        return;
                                    }
                                    if (applyColor) {
                                        coloredImages[colorNumber] = colorizeImage(texture.image, colorNumber)
                                            .then((urln) => {

                                                return new Promise((resolve, reject) => {

                                                    textureLoader.load(urln, function (newTexture) {

                                                            newTexture.colorSpace = THREE.SRGBColorSpace;
                                                            newTexture.flipY = false;
                                                            resolve(newTexture);
                                                        },
                                                        // onProgress callback currently not supported
                                                        undefined,
                                                        function (err) {
                                                            reject(texture);
                                                        });
                                                });
                                            });
                                    } else {
                                        coloredImages[colorNumber] = Promise.resolve(texture);
                                    }

                                }
                            }

                            let applyingTextureForModel =
                                coloredImages[colorNumber].then((texture) => {

                                    let material = child.material.clone();
                                    let isLastTexture = modelPart.userData.currentImageVersions[i][imageVersion.name] < imageVersion[i];
                                    if (imageVersion.name === 'texture') {
                                        isLastTexture = isLastTexture && modelPart.userData.currentImageVersions[i].color <= colorVersion[i];
                                    }


                                    if (texture != null && isLastTexture) {

                                        texture.needsUpdate = true;
                                        if (other_map === 'occlusionRoughnessMetallic') {
                                            let encoding =
                                                material.aoMap = texture;
                                            material.metalnessMap = texture;
                                            material.roughnessMap = texture;
                                            material.aoMap.encoding = modelPart.userData.originalMaterial[i]?.aoMap?.encoding || texture.encoding;
                                            material.metalnessMap.encoding = modelPart.userData.originalMaterial[i]?.metalnessMap?.encoding || texture.encoding;
                                            material.roughnessMap.encoding = modelPart.userData.originalMaterial[i]?.roughnessMap?.encoding || texture.encoding;
                                        } else if (other_map === 'normal') {

                                            material.normalMap = texture;
                                            material.normalMap.encoding = modelPart.userData.originalMaterial[i]?.normalMap?.encoding || texture.encoding;
                                        } else {

                                            modelPart.userData.currentImage[i] = texture.image;
                                            material.map = texture;
                                            material.map.encoding = modelPart.userData.originalMaterial[i]?.map?.encoding || texture.encoding;

                                            modelPart.userData.currentImageVersions[i].color = colorVersion[i];

                                        }

                                        modelPart.userData.currentImageVersions[i][imageVersion.name] = imageVersion[i];
                                    } else {

                                    }
                                    child.material = material;
                                    material.needsUpdate = true;
                                });
                            applyingTextureForModels.push(applyingTextureForModel);
                        }
                    })
                })
                .then(()=> Promise.all(applyingTextureForModels));
        loadingTextureForModels.push(loadingTexture);
    });
    return Promise.all(loadingTextureForModels);
}

function changeModelsTextureCustom(cs = '', other_map = '', url = '/assets/img/logo_icons/257x67_PSF Builder Logo.png', repeat = {
    x: 1,
    y: 1
}, rotate = false, is_need_mirror = true, otherModels = []) {

    let models = modelParts;
    if (Array.isArray(otherModels) && otherModels.length) {
        models = otherModels;
    }
    let textureLoader = new THREE.TextureLoader();
    let loadingTextureForModels = [];
    let applyingTextureForModels = [];
    models.forEach(function (modelPart) {
        if (modelPart.userData.isClone) {
            return;
        }


        let coloredImages = {};


        let imageExt = findOutImageExt(cs, modelPart.userData.imageExt);
        if (typeof imageExt === 'undefined') {
            imageExt = 'jpg';
        }
        let meshes = [];

        modelPart.traverse(function (child) {
            if (child instanceof THREE.Mesh) {
                meshes.push(child);
            }
        });
        let indexOfMesh = findOutIndexOfMeshes(cs, modelPart.userData.indexesOfMeshes);

        let checkIfYouNeedMeshWithThisIndex = getCheckerOfIndexes(indexOfMesh);

        let imageVersion = {};// for this img
        let colorVersion = {};// for this img
        meshes.forEach(function (child, i) {
            if (checkIfYouNeedMeshWithThisIndex(i)) {
                if (other_map === 'occlusionRoughnessMetallic') {
                    imageVersion[i] = ++modelPart.userData.counterImageVersions[i].occ;
                    imageVersion.name = 'occ';
                } else if (other_map === 'normal') {
                    imageVersion[i] = ++modelPart.userData.counterImageVersions[i].nm;
                    imageVersion.name = 'nm';
                } else {
                    imageVersion[i] = ++modelPart.userData.counterImageVersions[i].texture;
                    imageVersion.name = 'texture';
                    colorVersion[i] = modelPart.userData.counterImageVersions[i].color;
                }

            }
        });
        let loadingTexture =
            new Promise(function (resolve, reject) {

                let needLoadTexture = meshes.some((e, i) => checkIfYouNeedMeshWithThisIndex(i));
                if (!needLoadTexture) {
                    resolve();
                    return;
                }
                textureLoader.load(url, function (newTexture) {
                        let texture = repeatTexture(newTexture, repeat.x, repeat.y, is_need_mirror, rotate);
                        texture.magFilter = newTexture.magFilter;
                        texture.colorSpace = THREE.SRGBColorSpace;
                        texture.flipY = false;
                        texture.needsUpdate = true;
                        texture.anisotropy = renderer.capabilities.getMaxAnisotropy();
                        resolve(texture);
                        console.log('1706');
                    },
                    // onProgress callback currently not supported
                    undefined,
                    function (err) {
                        resolve();
                    });
            })
                .then(function (texture) {
                    meshes.forEach(function (child, i) {
                        if (checkIfYouNeedMeshWithThisIndex(i)) {

                            let colorNumber = modelPart.userData.currentColor[i];

                            if (colorNumber == null) {
                                colorNumber = 0x808080;
                            }

                            if (coloredImages[colorNumber] == null) {

                                if (other_map === 'occlusionRoughnessMetallic') {

                                    coloredImages[colorNumber] = Promise.resolve(texture);
                                } else if (other_map === 'normal') {

                                    coloredImages[colorNumber] = Promise.resolve(texture);
                                } else {
                                    console.log('1733');
                                    let image;

                                    if (texture == null && url !== '') {

                                        let originalM = modelPart.userData.originalMaterial[i];
                                        texture = originalM.map;
                                    }
                                    if (texture == null || texture.image == null) {

                                        return;
                                    }
                                     coloredImages[colorNumber] = Promise.resolve(texture);

                                }
                            }

                            let applyingTextureForModel =
                                coloredImages[colorNumber].then((texture) => {

                                    let material = child.material.clone();
                                    let isLastTexture = modelPart.userData.currentImageVersions[i][imageVersion.name] < imageVersion[i];
                                    if (imageVersion.name === 'texture') {
                                        isLastTexture = isLastTexture && modelPart.userData.currentImageVersions[i].color <= colorVersion[i];
                                    }


                                    if (texture != null && isLastTexture) {

                                        texture.needsUpdate = true;
                                        if (other_map === 'occlusionRoughnessMetallic') {

                                            material.aoMap = texture;
                                            material.metalnessMap = texture;
                                            material.roughnessMap = texture;
                                            material.aoMap.encoding = modelPart.userData.originalMaterial[i]?.aoMap?.encoding || texture.encoding;
                                            material.metalnessMap.encoding = modelPart.userData.originalMaterial[i]?.metalnessMap?.encoding || texture.encoding;
                                            material.roughnessMap.encoding = modelPart.userData.originalMaterial[i]?.roughnessMap?.encoding || texture.encoding;
                                        } else if (other_map === 'normal') {

                                            material.normalMap = texture;
                                            material.normalMap.encoding = modelPart.userData.originalMaterial[i]?.normalMap?.encoding || texture.encoding;
                                        } else {
                                            console.log('1776');
                                            modelPart.userData.currentImage[i] = texture.image;
                                            material.map = texture;
                                            material.map.encoding = modelPart.userData.originalMaterial[i]?.map?.encoding || texture.encoding;

                                            modelPart.userData.currentImageVersions[i].color = colorVersion[i];

                                        }

                                        modelPart.userData.currentImageVersions[i][imageVersion.name] = imageVersion[i];
                                    } else {

                                    }
                                    child.material = material;
                                    material.needsUpdate = true;
                                });
                            applyingTextureForModels.push(applyingTextureForModel);

                        }
                    });
                })
                .then(()=> Promise.all(applyingTextureForModels));

        loadingTextureForModels.push(loadingTexture);
    });
    return Promise.all(loadingTextureForModels)
        .then(() =>
            Promise.all(applyingTextureForModels)
        );

}

function changeModelsColor(cs = '', colorNumber = 0xFFFFFF, otherModels = []) {
    console.trace('color',cs, colorNumber, otherModels, otherModels?.map?.(element => element.userData.partId))
    let models = modelParts;
    if (Array.isArray(otherModels) && otherModels.length) {
        models = otherModels;
    }
    let images = [];
    let promises = [];
    let waiting_promises = [];
    let restartFunction = false;
    // return Promise.resolve() // fast remove change color
    {
        // // //log(change_map);

        let textureLoader = new THREE.TextureLoader();
        models.forEach(function (modelPart) {
            if (modelPart.userData.isClone) {
                return;
            }

            function checkIsNeedToReturn(i) {
                return restartFunction;
            }

            let meshes = [];

            modelPart.traverse(function (child) {
                if (child instanceof THREE.Mesh) {
                    meshes.push(child);
                }
            });

            let indexOfMesh = findOutIndexOfMeshes(cs, modelPart.userData.indexesOfMeshes);
            let checkIfYouNeedMeshWithThisIndex = getCheckerOfIndexes(indexOfMesh);
            let imageVersion = {};// for this img
            let colorVersion = {};// for this img
            let savedimageVersion = {};
            meshes.forEach(function (child, i) {
                if (checkIfYouNeedMeshWithThisIndex(i)) {
                    savedimageVersion[i] = modelPart.userData.currentImage[i];
                    imageVersion[i] = modelPart.userData.counterImageVersions[i].texture;
                    colorVersion[i] = ++modelPart.userData.counterImageVersions[i].color;
                }
            });
            meshes.forEach(function (child, i) {

                if (checkIfYouNeedMeshWithThisIndex(i)) {


                    let material = child.material.clone();
                    modelPart.userData.currentColor[i] = colorNumber;

                    let img = savedimageVersion[i];


                    let index = images.indexOf(img);
                    if (index < 0) {
                        let promis = colorizeImage(img, colorNumber)
                            .then(function (url) {

                                if (restartFunction) {
                                    return Promise.resolve();
                                }

                                return new Promise((resolve, reject) => {

                                    if (checkIsNeedToReturn(i)) {
                                        resolve();
                                        return;
                                    }
                                    textureLoader.load(url, function (newTexture) {
                                            if (checkIsNeedToReturn(i)) {
                                                resolve();
                                                return;
                                            }

                                            resolve(newTexture);

                                        },

                                        // onProgress callback currently not supported
                                        undefined,
                                        function (err) {

                                            resolve();

                                        });
                                });

                            })
                            .catch();
                        images.push(img);
                        promises.push(promis);
                        index = images.indexOf(img);
                    }
                    let waiting_promis = promises[index].then((newTexture) => {
                        let isLastTexture = modelPart.userData.currentImageVersions[i].texture <= imageVersion[i];
                        isLastTexture = isLastTexture && modelPart.userData.currentImageVersions[i].color < colorVersion[i];
                        if (newTexture == null || !isLastTexture) return;
                        newTexture.colorSpace = THREE.SRGBColorSpace;
                        newTexture.flipY = false;
                        material.map = newTexture;
                        material.map.anisotropy = renderer.capabilities.getMaxAnisotropy();
                        child.material = material;

                        modelPart.userData.currentImageVersions[i].color = colorVersion[i];
                        modelPart.userData.currentImageVersions[i].texture = imageVersion[i];
                    }).catch(console.error);
                    waiting_promises.push(waiting_promis);
                }
            });
        });
    }
    return Promise.all(waiting_promises);
}
// добавление/убирание доп. света
function changeLightning(count = 0, options = {}) {
    if (count === 0) {
        scene.remove(rectLight);
        scene.remove(rectLight2);

    } else {
        // scene.add(rectLight);
        // scene.add(rectLight2);


    }

}

function rotateModel(phi_angle, theta_angle, frames, radius = undefined) {
    // console.error('rotateModelrotateModel')
    // if phi_angle === 0 && theta_angle === 0 && radius === 0
    // it will set default (after load position of transformControl)
    stopAnimateOrbitControlsRotation();
    return new Promise(function (resolve, reject) {

        // //log('rotateModel---', phi_angle, theta_angle);
        // orbitControls.autoRotate = true;
        // orbitControls.autoRotateSpeed = 30.0;
        phi_angle = phi_angle * 2 * Math.PI / 360;
        theta_angle = theta_angle * 2 * Math.PI / 360;



        let spherical = new THREE.Spherical();
        let sphericalDelta = new THREE.Spherical();

        let offset = new THREE.Vector3();

        let quat = new THREE.Quaternion().setFromUnitVectors(orbitControls.object.up, new THREE.Vector3(0, 1, 0));
        let quatInverse = quat.clone().invert();

        let position = orbitControls.object.position;

        offset.copy(position).sub(orbitControls.target);

        // rotate offset to "y-axis-is-up" space
        offset.applyQuaternion(quat);

        // angle from z-axis around y-axis
        spherical.setFromVector3(offset);

        if(radius == null){// ignoring if not set
            radius = 0
        }
//     // //log(new THREE.Vector3().setFromSpherical(load_spherical),new THREE.Vector3().setFromSpherical(spherical));
//     // //log(load_spherical, spherical);
//     // //log( spherical.theta - (load_spherical.theta));
// //    //log( load_spherical);
        // load_spherical
        resolve();

        if (
            theta_angle + spherical.theta - load_spherical.theta > 0.000001 ||
            theta_angle + spherical.theta - load_spherical.theta < -0.000001 ||
            phi_angle + spherical.phi - load_spherical.phi > 0.000001 ||
            phi_angle + spherical.phi - load_spherical.phi < -0.000001 ||
            radius + spherical.radius - load_spherical.radius > 0.000001 ||
            radius + spherical.radius - load_spherical.radius < -0.000001
        ) {

            sphericalDelta.theta = theta_angle - (spherical.theta - load_spherical.theta);
            sphericalDelta.phi = phi_angle - (spherical.phi - load_spherical.phi);
            sphericalDelta.radius = radius - (spherical.radius - load_spherical.radius);
            // // //log(3, sphericalDelta);

            let multiplie_speed = 3;
            let all_count = frames;
            let count = all_count;
            let x = sphericalDelta.clone().theta;
            let y = sphericalDelta.clone().phi;
            let z = sphericalDelta.clone().radius;

            let u = 0;
            while (u <= all_count / 2) {
                x -= x * orbitControls.dampingFactor * multiplie_speed;
                y -= y * orbitControls.dampingFactor * multiplie_speed;
                z -= z * orbitControls.dampingFactor * multiplie_speed;
                u++;
            }

            let animate2 = function () {
                count--;
                if (count > 0) {
                    requestAnimationFrame(animate2);


                    if (count <= all_count / 2) {

                        spherical.theta += sphericalDelta.theta * orbitControls.dampingFactor * multiplie_speed;
                        spherical.phi += sphericalDelta.phi * orbitControls.dampingFactor * multiplie_speed;
                        spherical.radius += sphericalDelta.radius * orbitControls.dampingFactor * multiplie_speed;

                        sphericalDelta.phi -= sphericalDelta.phi * orbitControls.dampingFactor * multiplie_speed;
                        sphericalDelta.theta -= sphericalDelta.theta * orbitControls.dampingFactor * multiplie_speed;
                        sphericalDelta.radius -= sphericalDelta.radius * orbitControls.dampingFactor * multiplie_speed;

                    } else {
                        spherical.theta += x / (1 / orbitControls.dampingFactor - 1) * multiplie_speed;
                        sphericalDelta.theta -= x / (1 / orbitControls.dampingFactor - 1) * multiplie_speed;
                        x += x / (1 / orbitControls.dampingFactor - 1) * multiplie_speed;
                        spherical.phi += y / (1 / orbitControls.dampingFactor - 1) * multiplie_speed;
                        sphericalDelta.phi -= y / (1 / orbitControls.dampingFactor - 1) * multiplie_speed;
                        y += y / (1 / orbitControls.dampingFactor - 1) * multiplie_speed;
                        spherical.radius += z / (1 / orbitControls.dampingFactor - 1) * multiplie_speed;
                        sphericalDelta.radius -= z / (1 / orbitControls.dampingFactor - 1) * multiplie_speed;
                        z += z / (1 / orbitControls.dampingFactor - 1) * multiplie_speed;

                    }

                } else {
                    spherical.theta += sphericalDelta.theta;
                    spherical.phi += sphericalDelta.phi;
                    spherical.radius += sphericalDelta.radius;
                    // // //log(sphericalDelta.theta);
                    sphericalDelta.phi = 0;
                    sphericalDelta.theta = 0;
                    sphericalDelta.radius = 0;

                }


                // restrict theta to be between desired limits
                spherical.theta = Math.max(orbitControls.minAzimuthAngle, Math.min(orbitControls.maxAzimuthAngle, spherical.theta));

                // restrict phi to be between desired limits
                spherical.phi = Math.max(orbitControls.minPolarAngle, Math.min(orbitControls.maxPolarAngle, spherical.phi));

                spherical.makeSafe();
                // // //log(spherical.theta,count);
                // restrict radius to be between desired limits
                spherical.radius = Math.max(orbitControls.minDistance, Math.min(orbitControls.maxDistance, spherical.radius));


                offset.setFromSpherical(spherical);


                // // //log(1 , sphericalDelta, count);

                // rotate offset back to "camera-up-vector-is-up" space
                offset.applyQuaternion(quatInverse);


                position.copy(orbitControls.target).add(offset);

            };
            animate2();
        }
    })
}
function addZoom( radius_delta = 0,frames = 40) {
    // if phi_angle === 0 && theta_angle === 0 && radius === 0
    // it will set default (after load position of transformControl)

    stopAnimateOrbitControlsRotation();

    return new Promise(function (resolve, reject) {

        let spherical = new THREE.Spherical();
        let sphericalDelta = new THREE.Spherical();

        let offset = new THREE.Vector3();

        let quat = new THREE.Quaternion().setFromUnitVectors(orbitControls.object.up, new THREE.Vector3(0, 1, 0));
        let quatInverse = quat.clone().invert();

        let position = orbitControls.object.position;

        offset.copy(position).sub(orbitControls.target);

        // rotate offset to "y-axis-is-up" space
        offset.applyQuaternion(quat);

        // angle from z-axis around y-axis
        spherical.setFromVector3(offset);

        if(radius_delta == null){// ignoring if not set
            radius_delta = 0
        }

        resolve();

        if ( true
            // radius_delta + spherical.radius > 0.000001 ||
            // radius_delta + spherical.radius < -0.000001
        ) {


            sphericalDelta.radius = radius_delta;
            // // log(3, sphericalDelta);

            let multiplie_speed = 3;
            let all_count = frames;
            let count = all_count;
            let z = sphericalDelta.clone().radius;

            let u = 0;
            while (u <= all_count / 2) {
                z -= z * orbitControls.dampingFactor * multiplie_speed;
                u++;
            }

            let animate2 = function () {
                count--;
                if (count > 0) {
                    requestAnimationFrame(animate2);


                    if (count <= all_count / 2) {

                        spherical.radius += sphericalDelta.radius * orbitControls.dampingFactor * multiplie_speed;

                        sphericalDelta.radius -= sphericalDelta.radius * orbitControls.dampingFactor * multiplie_speed;

                    } else {
                        spherical.radius += z / (1 / orbitControls.dampingFactor - 1) * multiplie_speed;
                        sphericalDelta.radius -= z / (1 / orbitControls.dampingFactor - 1) * multiplie_speed;
                        z += z / (1 / orbitControls.dampingFactor - 1) * multiplie_speed;

                    }

                } else {
                    spherical.radius += sphericalDelta.radius;
                    sphericalDelta.radius = 0;

                }


                // restrict theta to be between desired limits
                spherical.radius = Math.max(orbitControls.minDistance, Math.min(orbitControls.maxDistance, spherical.radius));

                offset.setFromSpherical(spherical);
                // rotate offset back to "camera-up-vector-is-up" space
                offset.applyQuaternion(quatInverse);


                position.copy(orbitControls.target).add(offset);

            };
            animate2();
        }
    })
}
function colorChanger2OnClick(e) {
    console.log('2172');
    return new Promise(function (resolve, reject) {
        let el = e.target;
        // let indexofmesh = parseInt(document.getElementById('indexOfMesh').value);
        let indexofmesh;
        let color = el.dataset.color;
        let change_map;
        // // //log(e);
        // // //log(color);
        // // //log(el.dataset.mesh_info);


        if (typeof el.dataset.mesh_info === 'undefined' || typeof sceneInfo[modelIndex].color_changer_meshes === 'undefined' || typeof sceneInfo[modelIndex].color_changer_meshes[el.dataset.mesh_info] === 'undefined') {
            return
        } else {
            indexofmesh = sceneInfo[modelIndex].color_changer_meshes[el.dataset.mesh_info].index;
            change_map = sceneInfo[modelIndex].color_changer_meshes[el.dataset.mesh_info].change_map;
        }
        // // //log(indexofmesh);
        // // //log(remove_map);
        document.querySelectorAll('#' + el.dataset.mesh_info + ' > .options__item.active').forEach(function (changeModelBtn) {
            // // //log(changeModelBtn,changeModelBtn1);
            changeModelBtn.classList.remove('active');
        });
        document.querySelector('#' + el.dataset.mesh_info + ' [data-color="' + color + '"]').parentElement.parentElement.classList.add('active');
        changeModelsColor(indexofmesh, color)
            .then(resolve).catch()

    });
}

/*let colorChangerBtns2 = document.getElementsByClassName('glassColors');


[].slice.call(colorChangerBtns2).forEach(function(item) {
    //changeColor
    // //log('glassColors');
    item.addEventListener('click', function(e){colorChanger2OnClick(e)});
});*/

let scrollPreview = document.getElementById('scrollPreview');
scrollPreview.addEventListener('click', function (e) {
    let scroll = parseFloat(scrollPreview.getAttribute("data-scroll"));

    addZoom(scroll, 20);
    scrollPreview.setAttribute("data-scroll", '0');

});
// let minusScale = document.getElementById('minus-scale');
// minusScale.addEventListener('click', function (e) {
//     addZoom(1, 20);
// });

let createImageBtn = document.getElementById('createImage');
createImageBtn.addEventListener('click', function (e) {

    let file_name = createImageBtn.getAttribute("data-file_name");
    // //log(file_name);
    let resolution = {'width': 2560, 'height': 1440};
    let url = createImage('image/jpeg', resolution)
    downloadImage(file_name, url);
    createImageBtn.setAttribute("data-url", url);

    createImageBtn.setAttribute("data-file_name", 'fileName');
});

let previewResizer = document.getElementById('previewResizer');
previewResizer.addEventListener('click', function (e) {
    window._fullscreen3d = previewResizer.getAttribute("data-fullscreen") === 'true';
    if(window._fullscreen3d){
        document.body.classList.add('fullscreen3d')
    }
    if(!window._fullscreen3d){
        document.body.classList.remove('fullscreen3d')
    }
    onWindowResize()
});

function getCheckerOfIndexes(indexesOfMesh) {
    let checkIfYouNeedMeshWithThisIndex;

//console.log('getCheckerOfIndexes', indexesOfMesh)
    if (indexesOfMesh === 'all') {
        checkIfYouNeedMeshWithThisIndex = () => true;
    } else if ((typeof indexesOfMesh) === 'object') {
        let arr;
        arr = Object.values(indexesOfMesh);// if object to array
        arr = Array.from(// if strings to numbers
            arr, x => isNaN(x) ? -1 : parseInt(x)//if NaN will return -1
        );
        checkIfYouNeedMeshWithThisIndex = x => arr.indexOf(x) !== -1;
    } else {
        let indexOfMesh = isNaN(indexesOfMesh) ? -1 : parseInt(indexesOfMesh);
        checkIfYouNeedMeshWithThisIndex = x => indexOfMesh === x;
    }

    return checkIfYouNeedMeshWithThisIndex;
}

function setDefaultCameraPosAndZoom() {
    let spherical = new THREE.Spherical();
    let quat = new THREE.Quaternion().setFromUnitVectors(orbitControls.object.up, new THREE.Vector3(0, 1, 0));
    let quatInverse = quat.clone().invert();

    let position = orbitControls.object.position;

    let offset = new THREE.Vector3();

    offset.copy(position).sub(orbitControls.target);

    // rotate offset to "y-axis-is-up" space
    offset.applyQuaternion(quat);

    // angle from z-axis around y-axis
    spherical.setFromVector3(offset);


    spherical.theta = load_spherical.theta;
    spherical.phi = load_spherical.phi;
    spherical.radius = load_spherical.radius;


    // restrict theta to be between desired limits
    spherical.theta = Math.max(orbitControls.minAzimuthAngle, Math.min(orbitControls.maxAzimuthAngle, spherical.theta));

    // restrict phi to be between desired limits
    spherical.phi = Math.max(orbitControls.minPolarAngle, Math.min(orbitControls.maxPolarAngle, spherical.phi));

    // restrict radius to be between desired limits
    spherical.radius = Math.max(orbitControls.minDistance, Math.min(orbitControls.maxDistance, spherical.radius));


    spherical.makeSafe();


    offset.setFromSpherical(spherical);


    // // //log(1 , sphericalDelta, count);

    // rotate offset back to "camera-up-vector-is-up" space
    offset.applyQuaternion(quatInverse);


    position.copy(orbitControls.target).add(offset);


    orbitControls.update();

    renderer.render(scene, camera);

}

let g = window;
g['get_URL_of_defult_image_on_canvas'] = function (format, resolution) {

    setDefaultCameraPosAndZoom();

    return createImage(format, resolution)
};
g['setRotation'] = function (deg) {
    let i = 0
    currentModel.traverse(function (node) {
        // // //log(node);
        // // //log(node.type);
        if (node instanceof THREE.Mesh) {
            if (i === 0) node.rotation.y = Math.PI * 2 / 360 * deg;
            if (i === 1) node.rotation.y = Math.PI * 2 / 360 * deg;
            if (i === 2) node.rotation.y = Math.PI * 2 / 360 * deg;

            i++
        }


    });

};
function rotateMeshes(deg, axis, indexes_of_meshes, options = {}) {
    let optionsFromParams = Object.assign({
        rotateClones: true, rotateCurrentModel: true
    },options)
    if (deg == null) deg = 0

    let i = 0
    if(optionsFromParams.rotateCurrentModel){
        currentModel.traverse(function (node) {
            if (node instanceof THREE.Mesh) {
                // //log('node.position index of mesh = ' + i, node.position)
                if (indexes_of_meshes.indexOf(i) !== -1) rotateMesh(deg, 30, node.rotation, axis);
                i++;
            }
        });
    }

    if(optionsFromParams.rotateClones){
        currentModelClones.forEach((v)=>{
            let i = 0
            v.traverse(function (node) {
                if (node instanceof THREE.Mesh) {
                    // //log('node.position index of mesh = ' + i, node.position)
                    if (indexes_of_meshes.indexOf(i) !== -1) rotateMesh(deg, 30, node.rotation, axis);
                    i++;
                }
            });
        })
    }

}
function cloneModel(model, cloneCount = 5) {

    let x = 0;
    let offset = new THREE.Vector3()

    var box = new THREE.Box3().setFromObject( model );
    x = box.getSize(new THREE.Vector3()).x;
    offset.x = x;

    // let obj2 = new THREE.Object3D();
    // let obj3 = new THREE.Object3D();
    // obj2.copy(model);
    // obj3.copy(model);
    // //log('copy_in_right')
    let copy_in_right = true
    let x_multiplier = 1
    for (let i = 0; i < cloneCount; i++) {
        // //log('obj')


        let obj = userData.originalModel.clone()


        scene.add(obj);
        currentModelClones.push(obj);

        let second_multiplier = 1;
        if (copy_in_right) second_multiplier = -1;

        obj.position.set(x * x_multiplier * second_multiplier, 0, 0)

        if(x_multiplier % 2 === 1){
            let index_of_mesh = 0;
            obj.traverse(function (node) {
                if (node instanceof THREE.Mesh) {

                    node.rotation.y = Math.PI * 2 / 360 * 90;
                    index_of_mesh++;
                }

            });
        }

        copy_in_right = !copy_in_right;
        if (copy_in_right) x_multiplier++;
    }

    let index_of_mesh = 0;

    // model.traverse(function (node) {
    //     if (node instanceof THREE.Mesh) {
    //
    //         node.rotation.y = Math.PI * 2 / 360 * 90;
    //         index_of_mesh++;
    //     }
    //
    // });

}
function rotateMesh(deg, frames, rotation, axis) {
    let newRotatioAxis = Math.PI * 2 / 360 * -deg
    if (
        rotation[axis] - newRotatioAxis > 0.001 ||
        rotation[axis] - newRotatioAxis < -0.001
    ) {

        // // //log(3, sphericalDelta);
        let RotationYDelta = newRotatioAxis - rotation.y
        RotationYDelta = RotationYDelta % (Math.PI * 2)
        let multiplie_speed = 3;
        let all_count = frames;
        let count = all_count;
        let x = RotationYDelta;

        let u = 0;
        while (u <= all_count / 2) {
            x -= x * orbitControls.dampingFactor * multiplie_speed;
            u++;
        }

        let animate2 = function () {
            count--;
            if (count > 0) {
                requestAnimationFrame(animate2);


                if (count <= all_count / 2) {
                    rotation[axis] += RotationYDelta * orbitControls.dampingFactor * multiplie_speed;
                    RotationYDelta -= RotationYDelta * orbitControls.dampingFactor * multiplie_speed;
                } else {
                    rotation[axis] += x / (1 / orbitControls.dampingFactor - 1) * multiplie_speed;
                    RotationYDelta -= x / (1 / orbitControls.dampingFactor - 1) * multiplie_speed;
                    x += x / (1 / orbitControls.dampingFactor - 1) * multiplie_speed;

                }

            } else {
                rotation[axis] += RotationYDelta;
                RotationYDelta = 0

            }


            // restrict theta to be between desired limits
            // spherical.theta = Math.max(orbitControls.minAzimuthAngle, Math.min(orbitControls.maxAzimuthAngle, spherical.theta));

            // restrict phi to be between desired limits
            // spherical.phi = Math.max(orbitControls.minPolarAngle, Math.min(orbitControls.maxPolarAngle, spherical.phi));

            // spherical.makeSafe();
            // // //log(spherical.theta,count);
            // restrict radius to be between desired limits
            // spherical.radius = Math.max(orbitControls.minDistance, Math.min(orbitControls.maxDistance, spherical.radius));


            // offset.setFromSpherical(spherical);


            // // //log(1 , sphericalDelta, count);

            // rotate offset back to "camera-up-vector-is-up" space
            // offset.applyQuaternion(quatInverse);


            // position.copy(node.position).add(offset);

        };
        animate2();
    }
}


let lastFrameTime;
let isNeedToAnimateOrbitControlsRotation = false;

function stopAnimateOrbitControlsRotation() {
    isNeedToAnimateOrbitControlsRotation = false;
    rotateLoopAnimationBtn.setAttribute("data-is_playing", isNeedToAnimateOrbitControlsRotation)
    let btnId =  rotateLoopAnimationBtn.getAttribute("data-remove_autoRotate_className")
    let btn = document.getElementsByClassName(btnId)[0];
    if(btn != null) btn.classList.remove("autoRotate");

}

function animateOrbitControlsRotation() {


    let spherical = new THREE.Spherical();
    let sphericalDelta = new THREE.Spherical();

    let offset = new THREE.Vector3();

    let quat = new THREE.Quaternion().setFromUnitVectors(orbitControls.object.up, new THREE.Vector3(0, 1, 0));
    let quatInverse = quat.clone().invert();

    let position = orbitControls.object.position;

    offset.copy(position).sub(orbitControls.target);

    // rotate offset to "y-axis-is-up" space
    offset.applyQuaternion(quat);

    // angle from z-axis around y-axis
    spherical.setFromVector3(offset);


    let timeFromlastFrame = (performance.now() - lastFrameTime) / 1000; // in seconds
    let rotationsPerSecond = 1 / 8 // in seconds
    spherical.theta += 2 * Math.PI * timeFromlastFrame * rotationsPerSecond;
    // spherical.phi += sphericalDelta.phi;
    // // //log(sphericalDelta.theta);
    sphericalDelta.phi = 0;
    sphericalDelta.theta = 0;


    // restrict theta to be between desired limits
    spherical.theta = Math.max(orbitControls.minAzimuthAngle, Math.min(orbitControls.maxAzimuthAngle, spherical.theta));

    // restrict phi to be between desired limits
    spherical.phi = Math.max(orbitControls.minPolarAngle, Math.min(orbitControls.maxPolarAngle, spherical.phi));

    spherical.makeSafe();
    // // //log(spherical.theta,count);
    // restrict radius to be between desired limits
    spherical.radius = Math.max(orbitControls.minDistance, Math.min(orbitControls.maxDistance, spherical.radius));


    offset.setFromSpherical(spherical);


    // // //log(1 , sphericalDelta, count);

    // rotate offset back to "camera-up-vector-is-up" space
    offset.applyQuaternion(quatInverse);


    position.copy(orbitControls.target).add(offset);
    lastFrameTime = performance.now()
}

function setRotateloopAnimation(bool) {
    bool = !!bool
    isNeedToAnimateOrbitControlsRotation = false;
    if (bool) {
        isNeedToAnimateOrbitControlsRotation = true
        lastFrameTime = performance.now()
    }
    return isNeedToAnimateOrbitControlsRotation
}

function createImage(format = 'image/jpeg', resolution = 2560 / 1440) {


    if (typeof resolution === 'object' && typeof resolution.width === 'number' && typeof resolution.height === 'number') {
        camera.aspect = 2560 / 1440;
        camera.updateProjectionMatrix();
        renderer.setSize(2560, 1440);

        orbitControls.update();

        renderer.render(scene, camera);
    }
    let url = renderer.domElement.toDataURL(format);
    createImageBtn.a
    onWindowResize();


    return url;

}

function downloadImage(saveAsFileName = 'fileName', url) {
    // //log(saveAsFileName);

    if (!(typeof saveAsFileName === 'string' && saveAsFileName.length > 0)) {
        saveAsFileName = 'fileName';
    }
    let link = document.createElement('a');

    link.setAttribute('href', url);
    link.setAttribute('target', '_blank');
    link.setAttribute('download', saveAsFileName);

    link.click();
}

/*
* берет иначальную текстуру(патертн) исоздает из нее текстуру побольше
* */
function repeatTexture( texture , widthMultiplier = 1, heightMultiplier = 1, is_need_mirror = true, rotate = false) {

    let canvas = document.createElement('canvas');
    let context = canvas.getContext('2d');

    let img = texture.image;
    if(!rotate){
        canvas.width = img.width * widthMultiplier;
        canvas.height = img.height * heightMultiplier;
    }
    if(rotate){
        canvas.width = img.height * heightMultiplier;
        canvas.height = img.width * widthMultiplier;

        context.translate(heightMultiplier * img.height, 0)
        context.rotate(0.5 * Math.PI);
    }

    for (let w = 0; w < widthMultiplier; w++) {

        for (let h = 0; h < heightMultiplier; h++) {

            let x = 1
            let y = 1
            let dx = img.width * w
            let dy = img.height * h
            if(is_need_mirror && w % 2){
                x = -1
                dx = -dx - img.width
            }
            if(is_need_mirror && h % 2){
                y = -1
                dy = -dy - img.height

            }
            if(is_need_mirror){
                context.scale(x, y);
            }
            context.drawImage(img, dx, dy); //0 0
            if(is_need_mirror){
                context.scale(x, y);
            }
        }
    }
    let dataForCopy = context.getImageData(0, 0, canvas.width, canvas.height).data;
    const width = canvas.width;
    const height = canvas.height;

    const newData = new Uint8Array( width * height * 4);

    for (let i = 0; i < dataForCopy.length; i++) {
        newData[i] = dataForCopy[i];
    }
    return  new THREE.DataTexture( newData, width, height);
}
const animate = function () {
    requestAnimationFrame(animate);
    if (progressBarOnScreen) {
        upadateProgressDiv()
    }
    if (isNeedToAnimateOrbitControlsRotation) {
        animateOrbitControlsRotation()
    }
    // if(rotateloopAnimation){
    //     upadateProgressDiv()
    // }
    orbitControls.update();
    {
        progressiveSurfacemap.update(camera, params['Blend Window'], true);
        progressiveSurfacemap.update(true, new THREE.Vector3(0,0,0));
        for (let l = 0; l < dirLights.length; l++) {
            dirLights[l].position.set(
                lightOrigin.position.x + (Math.random() * params['Light Radius']),
                lightOrigin.position.y + (Math.random() * params['Light Radius']),
                lightOrigin.position.z + (Math.random() * params['Light Radius']));
        }
    }
     renderer.render(scene, camera);
  //  stats.update();

    // composer.render();
//

    if (currentModelLoaded && countOfLoadingChanges === 0 && savedFraction !== 100 && window.loading_steps === 0) {
        updateProgressBar(100)
        blurCanvas.classList.remove("loading");
    }
};

// code for using part of screen
function onWindowResize() {
    size_of_3d_preview = get_size_of_3d_preview(window._fullscreen3d);
    camera.aspect = size_of_3d_preview.width / size_of_3d_preview.height;
    camera.updateProjectionMatrix();
    renderer.setSize(size_of_3d_preview.width, size_of_3d_preview.height);
    // composer.setSize( size_of_3d_preview.width, size_of_3d_preview.height );


    upadateProgressDiv()

}
function findOutIndexOfMeshes(cs, indexes_of_meshes = '') {
    let indexes_of_mesh_arr = [];
    //lc1:0,lc2:1,fn:2

    if(typeof indexes_of_meshes === 'string' && indexes_of_meshes.length > 0){
        let indexOfMeshToJSObject = function (){
            let obj = {}
            try {
                obj = JSON.parse
                ('{"' +
                    (
                        indexes_of_meshes
                            .replaceAll(',', '","')
                            .replaceAll(':', '":"')
                    ) +
                    '"}'
                )
            } catch (e){
                console.error(e)
            }
            // console.log(obj, 'obj')

            return obj
        }

        let indexes_of_mesh = indexOfMeshToJSObject(indexes_of_meshes)[cs]
        // console.log(indexes_of_mesh, 'cs')
        // console.log(indexes_of_mesh, 'indexes_of_mesh')

        if (typeof indexes_of_mesh !== 'undefined') {
            indexes_of_mesh_arr = indexes_of_mesh
                .split('&')
                .map(function(str) {
                    return parseInt(str)
                });
        }

    }

    return indexes_of_mesh_arr;

}

function findOutImageExt(cs, extensions  = '') {
     let extensions_arr = [];
   // "pl:PNG,p1:PNG,p2:PNG,p3:PNG"
    if(typeof extensions === 'string' && extensions.length > 0){
        let extensionsToJSObject = function (){
            let obj = {}
            try {
                obj = JSON.parse
                ('{"' +
                    (
                        extensions
                            .replaceAll(',', '","')
                            .replaceAll(':', '":"')
                    ) +
                    '"}'
                )
            } catch (e){
                console.error(e)
            }
            // console.log(obj, 'obj')

            return obj
        }
        let extension = extensionsToJSObject();
          if (typeof extension !== 'undefined') {
            extensions_arr = extension;
         }
    }
    return extensions_arr[cs];
}

function upadateProgressDiv() {
    let viewportOffset = image_layers.getBoundingClientRect();
    progressDiv.style.width = get_size_of_3d_preview().width + 'px';
    progressDiv.style.top = viewportOffset.top + "px";
    progressDiv.style.left = viewportOffset.left + "px";
}


let blurCanvas;

function init() {

    scene.background = new THREE.Color(0xFFFFFF);

    progressiveSurfacemap = new ProgressiveLightMap( renderer, lightMapRes );
    for ( let l = 0; l < lightCount; l ++ ) {

        const dirLight = new THREE.DirectionalLight( 0xffffff, 1.0 / lightCount );
        dirLight.name = 'Dir. Light ' + l;
        dirLight.position.set( 200, 200, 200 );
        dirLight.castShadow = true;
        dirLight.shadow.camera.near = 100;
        dirLight.shadow.camera.far = 5000;
        dirLight.shadow.camera.right = 150;
        dirLight.shadow.camera.left = - 150;
        dirLight.shadow.camera.top = 150;
        dirLight.shadow.camera.bottom = - 150;
        dirLight.shadow.mapSize.width = shadowMapRes;
        dirLight.shadow.mapSize.height = shadowMapRes;
        lightmapObjects.push( dirLight );
        dirLights.push( dirLight );

    }
    /*
     *i.lightsStateVersion = s,
     i.needsLights && (u.ambientLightColor.value = r.state.ambient,
     u.lightProbe.value = r.state.probe,
     u.directionalLights.value = r.state.directional,
     u.directionalLightShadows.value = r.state.directionalShadow,
     u.spotLights.value = r.state.spot,
     u.spotLightShadows.value = r.state.spotShadow,
     u.rectAreaLights.value = r.state.rectArea,
     u.ltc_1.value = r.state.rectAreaLTC1,
     u.ltc_2.value = r.state.rectAreaLTC2,
     u.pointLights.value = r.state.point,
     u.pointLightShadows.value = r.state.pointShadow,
     u.hemisphereLights.value = r.state.hemi,
     u.directionalShadowMap.value = r.state.directionalShadowMap,
     u.directionalShadowMatrix.value = r.state.directionalShadowMatrix,
     u.spotShadowMap.value = r.state.spotShadowMap,
     u.spotShadowMatrix.value = r.state.spotShadowMatrix,
     u.pointShadowMap.value = r.state.pointShadowMap,
     u.pointShadowMatrix.value = r.state.pointShadowMatrix);

     */
    // создается свет
    RectAreaLightUniformsLib.init();

    {
        let rectLight = new THREE.RectAreaLight(0xffffff, lights_intensity.rect1, 1, 2);
        rectLight.position.set(5, 1.6, 0.55);
        rectLight.lookAt(new THREE.Vector3(0, 1.6, 0.55));
        //-----  scene.add(rectLight);
        //
     //   let rectLightHelper = new RectAreaLightHelper( rectLight , 0x6a05aa);
     //   rectLight.add( rectLightHelper );

        //light from right side
        let rectLight2 = new THREE.RectAreaLight(0xffffff, lights_intensity.rect2, 1, 2);
        rectLight2.position.set(5, 1.6, -0.55);
        rectLight2.lookAt(new THREE.Vector3(0, 1.6, -0.55));
        //-----  scene.add(rectLight2);

        //-----   let rectLightHelper2 = new RectAreaLightHelper( rectLight2 , 0x6a05aa);
        //-----   rectLight2.add( rectLightHelper2 );


        let rectLight3 = new THREE.RectAreaLight(0xffffff, lights_intensity.rect3, 1, 2);
        rectLight3.position.set(1.45, 1.6, 2);
        rectLight3.lookAt(new THREE.Vector3(1.45, 1.6, 0));
         // scene.add(rectLight3);

         //  let rectLightHelper3 = new RectAreaLightHelper( rectLight3 , 0x6a05aa);
       //   rectLight3.add( rectLightHelper3 );


        let rectLight32 = new THREE.RectAreaLight(0xffffff, lights_intensity.rect32, 1, 2.5);
        rectLight32.position.set(0.3, 1, 1);
        rectLight32.lookAt(new THREE.Vector3(0, 0, 0));
        scene.add(rectLight32);

      //  let rectLightHelper32 = new RectAreaLightHelper( rectLight32 , 0x6a05aa);
     //   rectLight32.add( rectLightHelper32 );



        let rectLight4 = new THREE.RectAreaLight(0xffffff, lights_intensity.rect4, 1, 2);
        rectLight4.position.set(2.55, 1.6, 2);
        rectLight4.lookAt(new THREE.Vector3(2.55, 1.6, 0));
     //  scene.add(rectLight4);

     //   let rectLightHelper4 = new RectAreaLightHelper( rectLight4 , 0x6a05aa);
       //    rectLight4.add( rectLightHelper4 );


        let rectLight6 = new THREE.RectAreaLight(0xffffff, lights_intensity.rect5, 1, 2);
        rectLight6.position.set(-1, 1.6, -2);
        rectLight6.lookAt(new THREE.Vector3(1.05, 1.6, 0));
        //    scene.add(rectLight6);

        //    let rectLightHelper6 = new RectAreaLightHelper( rectLight6 , 0x6a05aa);
        //   rectLight6.add( rectLightHelper6 );

        //back moright
        let rectLight5 = new THREE.RectAreaLight(0xffffff, lights_intensity.rect6, 1, 2);
        rectLight5.position.set(2.55, 1.6, -2);
        rectLight5.lookAt(new THREE.Vector3(2.55, 1.6, 0));
         scene.add(rectLight5);

        //let rectLightHelper5 = new RectAreaLightHelper( rectLight5 , 0x6a05aa);
        // rectLight5.add( rectLightHelper5 );

        //rect light to the left side of the model..
        let rectLight71 = new THREE.RectAreaLight(0xffffff, lights_intensity.rect7, 1, 3);
        rectLight71.position.set(-2, 0.4, 0);
        rectLight71.lookAt( 0, 0, 0 );
        //-----   scene.add(rectLight71);
        //
        // let rectLightHelper71 = new RectAreaLightHelper( rectLight71 , 0x6a05aa);
        // rectLight71.add( rectLightHelper71 );

        //rect light to the left side of the model..
        let rectLight81 = new THREE.RectAreaLight(0xffffff, lights_intensity.rect8, 1, 2);
        rectLight81.position.set(0, -0.01, 0);
        rectLight81.lookAt( 0, 0, 0 );
        //-----   scene.add(rectLight81);
        //
        // let rectLightHelper81 = new RectAreaLightHelper( rectLight81 , 0x6a05aa);
        //  rectLight81.add( rectLightHelper81 );


    }

    const dirLight = new THREE.DirectionalLight( 0xffffff, lights_intensity.dir2 );
    dirLight.color.setHSL( 0.1, 1, 0.95 );
    dirLight.position.set( 0, 0.75, 1 );
    dirLight.position.multiplyScalar( 10 );
    // scene.add( dirLight );

    dirLight.castShadow = true;

    dirLight.shadow.mapSize.width = 2048;
    dirLight.shadow.mapSize.height = 2048;

    const d = 10;

    dirLight.shadow.camera.left = - d;
    dirLight.shadow.camera.right = d;
    dirLight.shadow.camera.top = d;
    dirLight.shadow.camera.bottom = - d;

    console.log(dirLight.shadow.camera.near)
    dirLight.shadow.camera.near = 0.05;
    dirLight.shadow.camera.far = 20;
    dirLight.shadow.bias = - 0.0001;

    const dirLightHelper = new THREE.DirectionalLightHelper( dirLight,  20,0x6a05aa);
    // scene.add( dirLightHelper );


    const AmbLight = new THREE.AmbientLight(0xffffff, lights_intensity.amb);
     scene.add(AmbLight);

   //  const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444);
   //   hemiLight.position.set(0, 20, 0);


    // hemiLight = new THREE.HemisphereLight(0xffeeb1, 0x080820, 4);
    //hemiLight = new THREE.HemisphereLight(0xffffff, 0x080820, 4);
    const HemisphereLight =  new THREE.HemisphereLight(0xffffff, 0x080820, lights_intensity.hem); // сделал как в туторе
      scene.add(HemisphereLight);

    // const light1 = new THREE.HemisphereLight( 0xffffbb, 0x080820, 1 );
    //const helper = new THREE.HemisphereLightHelper( HemisphereLight, 5 );
    //scene.add( helper );


    //Create a DirectionalLight and turn on shadows for the light
    const light = new THREE.DirectionalLight( 0xffffff, lights_intensity.dir1, 100 );
    light.position.set( 0.02, 1, 0.02 ); //default; light shining from top
    light.castShadow = true; // default false
    light.shadow.mapSize.width = 512*2; // default
    light.shadow.mapSize.height = 512*2; // default
    light.shadow.camera.near = 0.6; // default
    light.shadow.camera.far = 12500; // default
    light.shadow.bias =  0.00001;

    scene.add( light );

    //spot light from front side of the model.
    let  spotLight1 = new THREE.SpotLight(0xffffff, lights_intensity.spot1);
    spotLight1.castShadow = false;
    spotLight1.shadow.bias = -0.001;
    spotLight1.shadow.mapSize.width = 1024;
    spotLight1.shadow.mapSize.height = 1024;
    spotLight1.shadow.radius = 100;
    spotLight1.shadow.camera.far = 20;
    // spotLight1.position.set(0, 2.2, -3);
    spotLight1.position.set(-0.2, 2.0, 3);
 // scene.add(spotLight1);

   //  const spotLightHelper = new THREE.SpotLightHelper( spotLight1 , 0x6a05aa);
   //  scene.add( spotLightHelper );


    //spot light from back side of the model.
    let  spotLight2 = new THREE.SpotLight(0xffffff, lights_intensity.spot2);
    spotLight2.castShadow = true;
    spotLight2.shadow.bias = -0.00001;
    spotLight2.shadow.mapSize.width = 156;
    spotLight2.shadow.mapSize.height = 156;
    spotLight2.shadow.radius = 5;
    spotLight2.shadow.camera.far = 2.8;
    spotLight2.position.set(-0.4,2.14, 0.4);
//    scene.add(spotLight2);

   //  const spotLightHelper2 = new THREE.SpotLightHelper( spotLight2 , 0x6a05aa);
   //  scene.add( spotLightHelper2 );

    //const helper = new THREE.CameraHelper( light.shadow.camera );
    // scene.add( helper );

    let PRODUCT_ID = product_id.value

//Soft Shadows
    //https://stackoverflow.com/search?q=%5Bthree.js%5D+soft+shadow
//https://threejs.org/docs/index.html#api/en/lights/shadows/DirectionalLightShadow
//https://live.vanmoof.com/site
//https://stackoverflow.com/questions/60907801/how-to-use-pcf-soft-shadows-in-three-js

    //example
    //https://sketchfab.com/3d-models/scientific-whiteboard-76b7c38b03c540a4a70bdc85882173e2


    //book
    //https://account.packtpub.com/account/details
 //   scene.add( new THREE.AxesHelper(1));
    // Add GROUND to the Scene
    /*  const groundGeo = new THREE.PlaneBufferGeometry( 10, 10 );
     // const groundMat = new THREE.MeshLambertMaterial( { color: 0x3f4f35 } );
      const groundMat = new THREE.MeshLambertMaterial( { color: 0xffffff } );
      const ground = new THREE.Mesh( groundGeo, groundMat );
      ground.position.y = 0;
      ground.rotation.x = - Math.PI / 2;
      ground.receiveShadow = true;
      scene.add( ground );*/
    // END -- Add GROUND to the Scene --




    let terrainGeo = new THREE.PlaneGeometry(10, 10);
    let terrainMaterial = new THREE.ShadowMaterial({opacity : 0.1});
    terrain = new THREE.Mesh(terrainGeo, terrainMaterial);

    terrain.position.y = -0; // CHANGED
    terrain.rotation.x = -Math.PI / 2;
    //  terrain.position.z = - 10;
    terrain.receiveShadow = true;


    // создается камера
    camera = new THREE.PerspectiveCamera(35, size_of_3d_preview.width / size_of_3d_preview.height, 0.01, 100);
    // выставляются настройки показа картинки в элемент
    renderer = new THREE.WebGLRenderer({antialias: true});

    /**
     Scene tone mapping
     */
    renderer.useLegacyLights = false;
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFShadowMap;
    //renderer.toneMapping = THREE.NoToneMapping;
    renderer.toneMapping = THREE.LinearToneMapping;
    //  renderer.toneMapping = THREE.ReinhardToneMapping;
    // renderer.toneMapping = THREE.CineonToneMapping;
    // renderer.toneMapping = THREE.ACESFilmicToneMapping;
    // renderer.toneMapping = THREE.ReinhardToneMapping;
    renderer.toneMappingExposure = 1;


    renderer.setClearColor(0x000000, 0);
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(size_of_3d_preview.width, size_of_3d_preview.height);


    // renderer.physicallyCorrectLights = true;
    renderer.domElement.classList.add("el-with-3d-preview");
    document.getElementById('image_layers').appendChild(renderer.domElement);

    // производительность на клиенте
    loader.setDRACOLoader(new DRACOLoader().setDecoderPath('/node_modules/three/examples/js/libs/draco/gltf/'));

    // создается туман
    scene.fog = new THREE.Fog(0xFFFFFF, 15, 50);

    /*progressBarDiv = document.createElement( 'div' );
    progressBarDiv.innerText = "Loading...";
    progressBarDiv.style.fontSize = "1em";
    progressBarDiv.style.color = "#888";
    progressBarDiv.style.display = "block";
    progressBarDiv.style.position = "absolute";
    progressBarDiv.style.top = "50%";
    progressBarDiv.style.width = get_size_of_3d_preview().width+'';
    progressBarDiv.style.textAlign = "center";
    updateProgressBar( 0 );
    showProgressBar();*/

    // настраиваем экран загрузки
    progressDiv = document.getElementById('loadScreen');
    elWith3dIco = document.getElementById('elWith3dIco');

    //move loader cover to match the image/model area
    let image_layers = document.getElementById('image_layers');
    let viewportOffset = image_layers.getBoundingClientRect();
    progressDiv.style.position = 'fixed';
    progressDiv.style.width = get_size_of_3d_preview().width + 'px';
    progressDiv.style.top = viewportOffset.top + "px";
    progressDiv.style.left = viewportOffset.left + "px";

    progressBarDiv = document.querySelector('#loadScreen .Bar');
    blurCanvas = document.querySelector('#image_layers .el-with-3d-preview');
    blurCanvas.classList.add("loading");

    elWith3dIco.style.position = 'px';

    progressBarDiv = document.querySelector('#loadScreen .Bar');
    blurCanvas = document.querySelector('#image_layers .el-with-3d-preview');
    blurCanvas.classList.add("loading");


    // загружаем окружение
    HDR_envmap(hdr_settings);

    // выводим экран загрузки
    updateProgressBar(0);
    showProgressBar();

    orbitControls = new OrbitControls(camera, renderer.domElement);





    orbitControls.minDistance = 500;
    orbitControls.maxDistance = 800;

    // orbitControls.enablePan = false;
    // orbitControls.enableZoom = false;
    // orbitControls.enableDamping = true;
    // orbitControls.minPolarAngle = 0.8;
    // orbitControls.maxPolarAngle = 2.4;
    orbitControls.dampingFactor = 0.07;
    // orbitControls.rotateSpeed = 0.07;

    // setting camera

    // orbitControls.enablePan = false;

    // Mouse buttons
    orbitControls.mouseButtons = {LEFT: THREE.MOUSE.ROTATE, MIDDLE: THREE.MOUSE.DOLLY, RIGHT: THREE.MOUSE.ROTATE};

    // Touch fingers
    orbitControls.touches = {ONE: THREE.TOUCH.ROTATE, TWO: THREE.TOUCH.ROTATE};
    orbitControls.addEventListener('start', ()=>{
        stopAnimateOrbitControlsRotation();
    });

    renderer.autoClear = false;


    // loadModel(startModelIndex, '/models/743/SMG1-5436_gltf/1024/out.glb');


    animate();

}


document.addEventListener('DOMContentLoaded', (event) => {
    //the event occurred
    init();


})
window.addEventListener('resize', onWindowResize)
